const TRANSLATIONS = {
  "tiw__back": {
    "key": "tiw__back",
    "ru": "Назад",
    "ro": "Inapoi",
    "en": "Back",
    "kz": "Кері",
    "ua": "Назад",
    "pl": "Powrót",
    "ge": "უკან",
    "az": "geri qayıt",
    "": ""
  },
  "tiw__continue": {
    "key": "tiw__continue",
    "ru": "Продолжить",
    "ro": "Continuă",
    "en": "Continue",
    "kz": "Жалғастыру",
    "ua": "Продовжити",
    "pl": "Kontynuuj",
    "ge": "გაგრძელება",
    "az": "Davam etmək",
    "": ""
  },
  "tiw__restart": {
    "key": "tiw__restart",
    "ru": "Начать заново",
    "ro": "Incepe din nou",
    "en": "Restart",
    "kz": "Қайтадан бастау",
    "ua": "Почати заново",
    "pl": "Uruchom ponownie",
    "ge": "თავიდან დაწყება",
    "az": "Yenidən başla",
    "": ""
  },
  "tiw__cancel": {
    "key": "tiw__cancel",
    "ru": "Отменить",
    "ro": "Anulează",
    "en": "Cancel",
    "kz": "Бас тарту",
    "ua": "Скасувати",
    "pl": "Anuluj",
    "ge": "გაუქმება",
    "az": "İmtina etmək",
    "": ""
  },
  "tiw__rollDown": {
    "key": "tiw__rollDown",
    "ru": "Свернуть",
    "ro": "Minimizează",
    "en": "Roll",
    "kz": "Жасыру",
    "ua": "Згорнути",
    "pl": "W dół",
    "ge": "ჩაკეცვა",
    "az": "Bağlamaq",
    "": ""
  },
  "tiw__hide": {
    "key": "tiw__hide",
    "ru": "Скрыть",
    "ro": "Ascunde",
    "en": "Hide",
    "kz": "Жасыру",
    "ua": "Приховати",
    "pl": "Ukryj",
    "ge": "დამალვა",
    "az": "Gizlətmək",
    "": ""
  },
  "tiw__close": {
    "key": "tiw__close",
    "ru": "Закрыть",
    "ro": "Inchide",
    "en": "Close",
    "kz": "Жабу",
    "ua": "Закрити",
    "pl": "Zamknij",
    "ge": "დახურვა",
    "az": "Bağlamaq",
    "": ""
  },
  "tiw__finish": {
    "key": "tiw__finish",
    "ru": "Закончить",
    "ro": "Termina",
    "en": "Finish",
    "kz": "Аяқтау",
    "ua": "Закінчити",
    "pl": "Zakończ",
    "ge": "დასრულება",
    "az": "Bitirmək",
    "": ""
  },
  "tiw__finishEntry": {
    "key": "tiw__finishEntry",
    "ru": "Закончить оформление",
    "ro": "Termina introducerea",
    "en": "Finish entry",
    "kz": "Аяқтау",
    "ua": "Закінчити",
    "pl": "Zakończ",
    "ge": "დასრულება",
    "az": "Bitirmək",
    "": ""
  },
  "tiw__notRequired": {
    "key": "tiw__notRequired",
    "ru": "Не обязательно",
    "ro": "Nu e obligatoriu",
    "en": "Not required",
    "kz": "Міндетті емес",
    "ua": "Не обов'язково",
    "pl": "Niewymagane",
    "ge": "არ არის სავალდებულო",
    "az": "Məcburi deyil",
    "": ""
  },
  "tiw__crunch__needHelp": {
    "key": "tiw__crunch__needHelp",
    "ru": "Нужна помощь?",
    "ro": "Ai nevoie de ajutor?",
    "en": "Do you need help?",
    "kz": "Көмек керек пе?",
    "ua": "Потрібна допомога?",
    "pl": "Potrzebujesz pomocy?",
    "ge": "გჭირდებათ დახმარება?",
    "az": "Kömək lazımdı?",
    "": ""
  },
  "tiw__crunch__contactUs": {
    "key": "tiw__crunch__contactUs",
    "ru": "Свяжитесь c нами",
    "ro": "Ia legătura cu noi<span style='user-select:none;color:initial;cursor:initial;'>us</span>",
    "en": "Contact us",
    "kz": "<span style='user-select:none;color:initial;cursor:initial;'>Бізге</span> хабарласыңыз",
    "ua": "Звʼяжіться з нами",
    "pl": "Skontaktuj się z <span style='user-select:none;color:initial;cursor:initial;'> nami</span>.",
    "ge": "დაგვეკონტაქტეთ <span style='user-select:none;color:initial;cursor:initial;'>us</span>",
    "az": "Bizlə ələqəyə keçin",
    "": ""
  },
  "tiw__crunch__liveChatUs": {
    key: "tiw__crunch__liveChatUs",
    "ru": "",
    "ro": "",
    "en": "Live chat us",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
  },
  "tiw__crunch__willAssistYou": {
    key: "tiw__crunch__willAssistYou",
    "ru": "",
    "ro": "",
    "en": "and one of our consultants will assist you",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
  },
  "tiw__validation__success": {
    "key": "tiw__validation__success",
    "ru": "Успешно",
    "ro": "Cu succes",
    "en": "Successfully",
    "kz": "Сәтті",
    "ua": "Успішно",
    "pl": "Sukces",
    "ge": "წარმატებით",
    "az": "Uğurlu",
    "": ""
  },
  "tiw__validation__undefined": {
    "key": "tiw__validation__undefined",
    "ru": "Для указанного поля валидация не настроена",
    "ro": "Validarea nu este configurată pentru câmpul specificat",
    "en": "Validation is not configured for the specified field",
    "kz": "Көрсетілген өріс үшін валидация орнатылмаған",
    "ua": "Для зазначеного поля валідація не налаштована",
    "pl": "Walidacja nie jest skonfigurowana dla określonego pola",
    "ge": "ამ კონკრეტული ველისთვის ვალიდაცია არ არის დაკონფიგურებული",
    "az": "Doğrulama müəyyən edilmiş sahə üçün konfiqurasiya edilməyib.",
    "": ""
  },
  "tiw__validation__file_choosePhoto": {
    "key": "tiw__validation__file_choosePhoto",
    "ru": "Выберите фото",
    "ro": "Alegeți fotografie",
    "en": "Select a photo",
    "kz": "Фотосуретті таңдаңыз",
    "ua": "Виберіть фото",
    "pl": "Wybierz zdjęcie",
    "ge": "აირჩიეთ ფოტო",
    "az": "Şəkili seçin",
    "": ""
  },
  "tiw__validation__file_maxSize": {
    "key": "tiw__validation__file_maxSize",
    "ru": "Превышен максимально допустимый (10 мб) размер файла. Выберите другое фото",
    "ro": "Limită maximală admisibilă (10MB) a fost trecută.Alegeți altă fotografie",
    "en": "The maximum allowed file size (10 MB) has been exceeded. Choose another photo",
    "kz": "Рұқсат етілген ең үлкен (10 мб) файл өлшемінен асып кетті. Басқа фотосуретті таңдаңыз",
    "ua": "Перевищено максимально допустимий (10 Мб) розмір файлу. Виберіть інше фото",
    "pl": "Przekroczono maksymalny dozwolony rozmiar pliku (10 MB). Wybierz inne zdjęcie",
    "ge": "ფოტო აჭარბებს მაქსიმალურ დასაშვებ ზომას (10 MB). აირჩიეთ სხვა ფოტო",
    "az": "Maksimum fayl ölçüsü (10 MB) aşıldı. Başqa bir şəkil seçin",
    "": ""
  },
  "tiw__validation__file_wrongExt": {
    "key": "tiw__validation__file_wrongExt",
    "ru": "Расширение загружаемого Вами файла не поддерживается для загрузки. Допустимы файлы с расширением \".jpg, .jpeg, .bmp, .png или .heic\"",
    "ro": "Extensia fișierului pe care încercați să îl încărcați nu este acceptată. Sunt permise fișiere cu extensia \".jpg, .jpeg, .bmp, .png sau .heic\"",
    "en": "The file extension you are downloading is not supported for download. Files with the extension \" are allowed.jpg, .jpeg, .bmp, .png or .heic\"",
    "kz": "Сіз жүктеген файл кеңейтіміне жүктеу үшін қолдау көрсетілмейді. Кеңейтімі бар файлдар жарамды \".jpg, .jpeg, .bmp, .png немесе .heic\"",
    "ua": "Розширення файлу не підтримується для завантаження. Допустимі файли з розширенням \".jpg, .jpeg, .bmp, .png або .heic\"",
    "pl": "Rozszerzenie pobieranego pliku nie jest obsługiwane. Dozwolone są pliki z rozszerzeniem \".jpg, .jpeg, .bmp, .png lub .heic\".",
    "ge": "ფოტოს ფორმატი, რომელსაც იწერთ არ არის მხარდაჭერილი. დაშვებული ფორმატებია: .jpg, .jpeg, .bmp, .png ან .heic",
    "az": "Yüklədiyiniz faylın genişləndirilməsi yükləmə üçün dəstəklənmir. \".jpg, .jpeg, .bmp, .png və ya .heic\" uzantılı fayllar qəbul edilir.",
    "": ""
  },
  "tiw__validation__fio_required": {
    "key": "tiw__validation__fio_required",
    "ru": "Поле ФИО обязательно к заполнению",
    "ro": "Câmpul Nume, Prenume, Patronimicul este obligatoriu",
    "en": "The full name field must be filled in",
    "kz": "Аты жөні өрісі міндетті түрде толтырылады",
    "ua": "Поле ПІБ обовʼязкове для заповнення",
    "pl": "Pole \"Pełne Imię\" musi być wypełnione",
    "ge": "სრული სახელის ველი აუცილებლად უნდა იყოს შევსებული",
    "az": "SAA sahəsinin doldurulması tələb olunur",
    "": ""
  },
  "tiw__validation__fio_range": {
    "key": "tiw__validation__fio_range",
    "ru": "Поле ФИО должно иметь от 10 до 50 символов",
    "ro": "Câmpul Nume, Prenume, Patronimicul trebuie sa conține de la 10 pană la 50 de simboluri",
    "en": "The full name field must have from 10 to 50 characters",
    "kz": "Аты жөні өрісінде 10 дан 50 ге дейін таңба болуы керек",
    "ua": "Поле ПІБ повинно мати від 10 до 50 символів",
    "pl": "Pole \"Pełne Imię\" musi zawierać od 10 do 50 znaków.",
    "ge": "სრული სახელის ველი უნდა შეიცავდეს 10-დან 50-მდე სიმბოლოს",
    "az": "SAA sahəsi 10 ilə 50 simvol arasında olmalıdır.",
    "": ""
  },
  "tiw__validation__fio_symbols": {
    "key": "tiw__validation__fio_symbols",
    "ru": "Поле ФИО содержит недопустимые символы пунктуации кроме \"-\" или повторяющийся 2 раза под ряд символ пробела",
    "ro": "Câmpul Nume, Prenume, Patronim conține simboluri de punctuație nepermise, cu excepția caracterului \"-\", sau un caracter spațiu care se repetă de două ori consecutiv.",
    "en": "The FULL NAME field contains invalid punctuation characters other than \"-\" or a space character repeated 2 times in a row",
    "kz": "Аты-жөні өрісінде \"-\" немесе қатарынан 2 рет қайталанатын бос орыннан басқа рұқсат етілмеген тыныс белгілері бар",
    "ua": "Поле ПІБ містить неприпустимі символи пунктуації (крім \"-\" або повторюваний 2 рази підряд символ пробілу)",
    "pl": "Pole PEŁNE IMIĘ zawiera nieprawidłowe znaki interpunkcyjne inne niż \"-\" lub znak spacji powtórzony 2 razy z rzędu.",
    "ge": "სრული სახელის ველი შეიცავს არასწორ პუნქტუაციის სიმბოლოებს „-“-ს ან ინტერვალის სიმბოლოს, რომელიც ზედიზედ 2-ჯერ მეორდება.",
    "az": "SAA sahəsində \"-\" və ya ardıcıl iki dəfə təkrarlanan boşluq simvolundan başqa etibarsız durğu işarələri var",
    "": ""
  },
  "tiw__validation__imei_required": {
    "key": "tiw__validation__imei_required",
    "ru": "Поле IMEI обязательно к заполнению",
    "ro": "Câmpul IMEI este obligatoriu",
    "en": "The IMEI field must be filled in",
    "kz": "IMEI өрісі міндетті түрде толтырылады",
    "ua": "Поле IMEI обов'язкове до заповнення",
    "pl": "Pole IMEI musi być wypełnione",
    "ge": "IMEI-ს ველი უნდა იყოს შევსებული",
    "az": "IMEI sahəsi tələb olunur.",
    "": ""
  },
  "tiw__validation__imei_range": {
    "key": "tiw__validation__imei_range",
    "ru": "Поле IMEI должно состоять только из цифр и не менее 15 символов",
    "ro": "Câmpul IMEI trebuie să conțină doar cifre și să aibă cel puțin 15 caractere",
    "en": "The IMEI field must consist of only numbers and at least 15 characters",
    "kz": "IMEI өрісі тек сандардан және кем дегенде 15 таңбадан тұруы керек",
    "ua": "Поле IMEI має складатися лише з цифр (менше 15 символів)",
    "pl": "Pole IMEI musi składać się wyłącznie z cyfr i co najmniej 15 znaków.",
    "ge": "IMEI-ს ველი უნდა შეიცავდეს მხოლოდ ციფრებს, სულ მცირე 15ც.",
    "az": "IMEI sahəsi yalnız rəqəmlərdən ibarət olmalı və ən azı 15 simvol uzunluğunda olmalıdır.",
    "": ""
  },
  "tiw__validation__inn_required": {
    "key": "tiw__validation__inn_required",
    "ru": "Поле обязательно к заполнению",
    "ro": "Câmpul este obligatoriu",
    "en": "The field must be filled in",
    "kz": "Өрісі міндетті түрде толтырылады",
    "ua": "Поле обов'язкове до заповнення",
    "pl": "Pole musi być wypełnione",
    "ge": "ველი უნდა იყოს შევსებული",
    "az": "Sahə tələb olunur.",
    "": ""
  },
  "tiw__validation__inn_range": {
    "key": "tiw__validation__inn_range",
    "ru": "Поле должно состоять только из цифр и в диапазоне 10-12 символов",
    "ro": "Câmpul trebuie să conțină doar cifre si să aibă 10-12 caractere",
    "en": "The field should consist only of numbers and in the range of 10-12 characters",
    "kz": "Өрісі тек сандардан және 10-12 таңбадан тұруы керек",
    "ua": "Поле має складатися тільки з цифр (10-12 символів)",
    "pl": "Pole powinno składać się wyłącznie z cyfr i zawierać od 10 do 12 znaków.",
    "ge": "ველი უნდა შედგებოდეს მხოლოდ ციფრებისგან და 10-12 სიმბოლოს დიაპაზონში.",
    "az": "Sahə yalnız rəqəmlərdən ibarət olmalı və 10-12 simvol diapazonunda olmalıdır.",
    "": ""
  },
  "tiw__validation__idnp_range_md": {
    "key": "tiw__validation__idnp_range_md",
    "ru": "Поле должно состоять только из 13 цифр",
    "ro": "Câmpul trebuie să conțină exact 13 cifre",
    "en": "The field must consist of exactly 13 digits",
    "kz": "Өріс тек 13 цифрдан тұруы керек",
    "ua": "Поле має складатися тільки з 13 цифр",
    "pl": "Pole powinno składać się wyłącznie z 13 cyfr",
    "ge": "ველი უნდა შედგებოდეს მხოლოდ 13 ციფრისგან",
    "az": "Sahə yalnız 13 rəqəmdən ibarət olmalıdır",
    "": ""
  },
  "tiw__validation__email_required": {
    "key": "tiw__validation__email_required",
    "ru": "Поле Email обязательно к заполнению",
    "ro": "Câmpul Email este obligatoriu",
    "en": "The Email field must be filled in",
    "kz": "Email өрісі міндетті түрде толтырылады",
    "ua": "Поле Email обов'язкове до заповнення",
    "pl": "Pole Email musi być wypełnione",
    "ge": "eMail ველი უნდა იყოს შევსებული",
    "az": "E-poçt sahəsi tələb olunur.",
    "": ""
  },
  "tiw__validation__email_incorrect": {
    "key": "tiw__validation__email_incorrect",
    "ru": "Введите корректный Email",
    "ro": "Introduceți adresa de Email corectă",
    "en": "Enter the correct Email address",
    "kz": "Дұрыс электрондық поштаны енгізіңіз",
    "ua": "Введіть правильний Email",
    "pl": "Wprowadź poprawny adres e-mail.",
    "ge": "გთხოვთ, შეიყვანეთ სწორი მეილი",
    "az": "Düzgün E-poçtu daxil edin",
    "": ""
  },
  "tiw__validation__phone_required": {
    "key": "tiw__validation__phone_required",
    "ru": "",
    "ro": "",
    "en": "",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "Telefon nömrəsi tələb olunur",
    "": ""
  },
  "tiw__validation__phone_range": {
    "key": "tiw__validation__phone_range",
    "ru": "Поле Телефон должно быть в диапазоне 14-18 символов",
    "ro": "Câmpul Număr de telefon trebuie să fie intre 9 și 13 caractere",
    "en": "The Phone field should be in the range of 14-18 characters",
    "kz": "Телефон өрісі 14-18 таңбадан тұруы керек",
    "ua": "Поле Телефон має бути в діапазоні 10-12 символів",
    "pl": "Pole Telefon powinno zawierać od 14 do 18 znaków.",
    "ge": "მობილური ნომრის ველი უნდა იყოს 14-18 ციფრის დიაპაზონში",
    "az": "Telefon sahəsi 14-18 simvol arasında olmalıdır.",
    "": ""
  },
  "tiw__grades__Q_stateInfo": {
    "key": "tiw__grades__Q_stateInfo",
    "ru": "Идеальное",
    "ro": "Perfectă",
    "en": "Perfect",
    "kz": "Mінсіз",
    "ua": "Ідеальне",
    "pl": "Idealny",
    "ge": "ახალივით",
    "az": "Mükəmməl",
    "": ""
  },
  "tiw__grades__Q_description": {
    "key": "tiw__grades__Q_description",
    "ru": "Устройство в идеальном состоянии",
    "ro": "Dispozitivul este în stare ideală",
    "en": "The device is in perfect condition",
    "kz": "Құрылғы мінсіз күйде",
    "ua": "Пристрій в ідеальному стані",
    "pl": "Urządzenie jest w idealnym stanie",
    "ge": "მოწყობილობა ახალივითაა",
    "az": "Cihaz ideal vəziyyətdədir",
    "": ""
  },
  "tiw__grades__A+_stateInfo": {
    "key": "tiw__grades__A+_stateInfo",
    "ru": "Идеальное",
    "ro": "Perfectă",
    "en": "Perfect",
    "kz": "Mінсіз",
    "ua": "Ідеальне",
    "pl": "Idealny",
    "ge": "ახალივით",
    "az": "Mükəmməl",
    "": ""
  },
  "tiw__grades__A+_description": {
    "key": "tiw__grades__A+_description",
    "ru": "Устройство в идеальном состоянии",
    "ro": "Dispozitivul este în stare ideală",
    "en": "The device is in perfect condition",
    "kz": "Құрылғы мінсіз күйде",
    "ua": "Пристрій в ідеальному стані",
    "pl": "Urządzenie jest w idealnym stanie",
    "ge": "მოწყობილობა ახალივითაა",
    "az": "Cihaz ideal vəziyyətdədir",
    "": ""
  },
  "tiw__grades__A_stateInfo": {
    "key": "tiw__grades__A_stateInfo",
    "ru": "Отличное",
    "ro": "Excelentă",
    "en": "Excellent",
    "kz": "Өте жақсы",
    "ua": "Відмінне",
    "pl": "Doskonały",
    "ge": "იდეალური",
    "az": "Əla",
    "": ""
  },
  "tiw__grades__A_description": {
    "key": "tiw__grades__A_description",
    "ru": "Устройство в отличном состоянии",
    "ro": "Dispozitivul este în stare excelentă",
    "en": "The device is in excellent condition",
    "kz": "Құрылғы өте жақсы күйде",
    "ua": "Пристрій у відмінному стані",
    "pl": "Urządzenie jest w doskonałym stanie",
    "ge": "მოწყობილობა იდეალურ მდგომარეობაშია",
    "az": "Cihaz əla vəziyyətdədir",
    "": ""
  },
  "tiw__grades__B_stateInfo": {
    "key": "tiw__grades__B_stateInfo",
    "ru": "Хорошее",
    "ro": "Bună",
    "en": "Good",
    "kz": "Жақсы",
    "ua": "Гарне",
    "pl": "Dobry",
    "ge": "კარგი",
    "az": "yaxşı",
    "": ""
  },
  "tiw__grades__B_description": {
    "key": "tiw__grades__B_description",
    "ru": "Устройство в хорошем состоянии",
    "ro": "Dispozitivul este în stare bună",
    "en": "The device is in good condition",
    "kz": "Құрылғы жақсы күйде",
    "ua": "Пристрій у гарному стані",
    "pl": "Urządzenie jest w dobrym stanie",
    "ge": "მოწყობილობა კარგ მდგომარეობაშია",
    "az": "Cihaz yaxşı vəziyyətdədir",
    "": ""
  },
  "tiw__grades__C_stateInfo": {
    "key": "tiw__grades__C_stateInfo",
    "ru": "Со следами эксплуатации",
    "ro": "Cu urme de folosire",
    "en": "With traces of exploitation",
    "kz": "Пайдалану іздері бар",
    "ua": "Зі слідами експлуатації",
    "pl": "Ze śladami użytkowania",
    "ge": "გამოყენების აშკარა კვალით",
    "az": "İstifadə izləri ilə",
    "": ""
  },
  "tiw__grades__C_description": {
    "key": "tiw__grades__C_description",
    "ru": "Устройство со следами эксплуатации",
    "ro": "Dispozitivul cu urme de folosire",
    "en": "A device with traces of operation",
    "kz": "Пайдалану іздері бар құрылғы",
    "ua": "Пристрій зі слідами експлуатації",
    "pl": "Urządzenie ze śladami użytkowania",
    "ge": "მოწყობილობას გააჩნია გამოყენების აშკარა კვალი",
    "az": "Cihaz istifadə izləri ilə",
    "": ""
  },
  "tiw__grades__D_stateInfo": {
    "key": "tiw__grades__D_stateInfo",
    "ru": "Со значительными следами эксплуатации",
    "ro": "Cu urme semnificative de folosire ",
    "en": "With significant traces of exploitation",
    "kz": "Пайдаланудың елеусіз іздері бар",
    "ua": "Зі значними слідами експлуатації",
    "pl": "Ze znacznymi śladami użytkowania",
    "ge": "მნიშვნელოვანი გამოყენების კვალი",
    "az": "Əhəmiyyətli istifadə izləri ilə",
    "": ""
  },
  "tiw__grades__D_description": {
    "key": "tiw__grades__D_description",
    "ru": "Устройство со значительными следами эксплуатации",
    "ro": "Dispozitivul cu urme semnificative de folosire",
    "en": "A device with significant traces of operation",
    "kz": "Елеулісіз пайдалану іздері бар құрылғы",
    "ua": "Пристрій зі значними слідами експлуатації",
    "pl": "Urządzenie ze znaczącymi śladami użytkowania",
    "ge": "მოწყობილობას გააჩნია გამოყენების მნიშვნელოვანი კვალი",
    "az": "Cihaz əhəmiyyətli istifadə izləri ilə",
    "": ""
  },
  "tiw__grades__E_stateInfo": {
    "key": "tiw__grades__E_stateInfo",
    "ru": "Критическое",
    "ro": "Critică",
    "en": "Critical",
    "kz": "Сыни",
    "ua": "Критичне",
    "pl": "Krytyczny",
    "ge": "კრიტიკული",
    "az": "Kritik",
    "": ""
  },
  "tiw__grades__E_description": {
    "key": "tiw__grades__E_description",
    "ru": "Устройство с критическими дефектами",
    "ro": "Dispozitivul cu defecte critice",
    "en": "A device with critical defects",
    "kz": "Сыни ақаулары бар құрылғы",
    "ua": "Пристрій з критичними дефектами",
    "pl": "Urządzenie z krytycznymi usterkami",
    "ge": "მოწყობილობას გააჩნია კრიტიკული დეფექტები",
    "az": "Kritik qüsurları olan cihaz",
    "": ""
  },
  "tiw__vselect__notFound": {
    "key": "tiw__vselect__notFound",
    "ru": "Извините. Совпадений не найдено.",
    "ro": "Îmi pare rău. Nu s-au găsit rezultate",
    "en": "Sorry. No matches were found.",
    "kz": "Кешіріңіз. Сәйкестік табылған жоқ.",
    "ua": "Вибачте. Збігів не знайдено.",
    "pl": "Przepraszamy. Nie znaleziono dopasowań.",
    "ge": "ვწუხვარ, არ ემთხვევა",
    "az": "Bağışlayın. Heç bir uyğunluq tapılmadı.",
    "": ""
  },
  "tiw__salesDevice__title": {
    "key": "tiw__salesDevice__title",
    "ru": "Покупаемое устройство",
    "ro": "Dispozitiv achiziționat",
    "en": "The device to be bought",
    "kz": "Сатып алынатын құрылғы",
    "ua": "Пристрій, що купується",
    "pl": "Nowe urządzenie kupowane",
    "ge": "შესასყიდი მოწყობილობა",
    "az": "Alınan cihaz",
    "": ""
  },
  "tiw__handedDevice__title": {
    "key": "tiw__handedDevice__title",
    "ru": "Сдаваемое устройство",
    "ro": "Dispozitiv predat",
    "en": "Your device",
    "kz": "Өткізілетін құрылғы",
    "ua": "Пристрій, що здається",
    "pl": "Urządzenie do odkupu",
    "ge": "გასაცემი მოწყობილობა",
    "az": "verilən cihaz",
    "": ""
  },
  "tiw__handedDevice__opportunity": {
    "key": "tiw__handedDevice__opportunity",
    "ru": "Вы можете загрузить дополнительные фото согласно инструкции, в этом случае стоимость выкупа может быть увеличена",
    "ro": "Puteți încărca fotografii suplimentare conform instrucțiunilor, caz în care prețul de răscumpărare poate fi majorat",
    "en": "You can upload additional photos according to the instructions, in which case the purchase price may be increased",
    "kz": "Нұсқаулыққа сәйкес қосымша фотосуреттерді жүктеуге болады, бұл жағдайда сатып алу құнын артуы мүмкін",
    "ua": "Ви можете завантажити додаткові фото згідно з інструкцією, у цьому випадку вартість викупу може бути збільшена",
    "pl": "Możesz przesłać dodatkowe zdjęcia zgodnie z instrukcjami, w takim przypadku wartość odkupu może wzrosnąć.",
    "ge": "შეგიძლიათ დამატებითი ფოტოების ატვირთვა ინსტრუქციის მიხედვით, ამ შემთხვევაში შესყიდვის ფასი შეიძლება გაიზარდოს",
    "az": "Təlimatlara uyğun olaraq əlavə fotoşəkillər yükləyə bilərsiniz, bu halda alış qiyməti artırıla bilər",
    "": ""
  },
  "tiw__handedDevice__unknownGrade": {
    "key": "tiw__handedDevice__unknownGrade",
    "ru": "Состояние устройства не определено",
    "ro": "Starea dispozitivului nu a fost determinată",
    "en": "The device status is not defined",
    "kz": "Құрылғының күйі анықталмады",
    "ua": "Стан пристрою не визначено",
    "pl": "Grade urządzenia nie został określony",
    "ge": "მოწყობილობის სტატუსი ვერ იქნა დადგენილი",
    "az": "Cihazın vəziyyəti müəyyən edilməyib",
    "": ""
  },
  "tiw__handedDevice__deviceTerminated": {
    "key": "tiw__handedDevice__deviceTerminated",
    "ru": "К сожалению, данное устройство в таком состоянии выкупу не подлежит",
    "ro": "Din păcate, acest dispozitiv în această stare nu este eligibil pentru răscumpărare",
    "en": "Unfortunately, this device is not redeemable in this condition",
    "kz": "Өкінішке орай, бұл құрылғы мұндай жағдайда сатып алуға жатпайды",
    "ua": "На жаль, цей пристрій у такому стані викупу не підлягає",
    "pl": "Niestety, to urządzenie nie może zostać odkupione w tym stanie.",
    "ge": "სამწუხაროდ მოწყობილობის ამ მდგომარეობაში მიღება არ არის შესაძლებელი",
    "az": "Təəssüf ki, bu vəziyyətdə olan bu cihaz geri alına bilməz.",
    "": ""
  },
  "tiw__handedDevice__valuation": {
    "key": "tiw__handedDevice__valuation",
    "ru": "Оценка устройства",
    "ro": "Evaluarea dispozitivului",
    "en": "Preliminary estimate",
    "kz": "Құрылғыны бағалау",
    "ua": "Оцінка пристрою",
    "pl": "Wycena urządzenia",
    "ge": "მოწყობილობის შეფასება",
    "az": "Cihazın qiymətləndirilməsi",
    "": ""
  },
  "tiw__handedDevice__condition": {
    "key": "tiw__handedDevice__condition",
    "ru": "",
    "ro": "",
    "en": "Condition",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__handedDevice__deviceValuation": {
    "key": "tiw__handedDevice__deviceValuation",
    "ru": "",
    "ro": "",
    "en": "Device valuation",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__calculatedDevice__title_pre": {
    "key": "tiw__calculatedDevice__title_pre",
    "ru": "Предварительная цена",
    "ro": "Prețul prealabil",
    "en": "Preliminary price",
    "kz": "Алдын ала бағасы",
    "ua": "Попередня ціна",
    "pl": "Wycena wstępna",
    "ge": "წინასწარი ფასი",
    "az": "İlkin qiymət",
    "": ""
  },
  "tiw__calculatedDevice__title_fin": {
    "key": "tiw__calculatedDevice__title_fin",
    "ru": "Финальная цена",
    "ro": "Prețul final",
    "en": "Final price",
    "kz": "Соңғы баға",
    "ua": "Фінальна ціна",
    "pl": "Wycena końcowa",
    "ge": "საბოლოო ღირებულება",
    "az": "Yekun qiymət",
    "": ""
  },
  "tiw__calculatedDevice__price_list_costNewDevice": {
    "key": "tiw__calculatedDevice__price_list_costNewDevice",
    "ru": "Цена нового устройства",
    "ro": "Prețul dispozitivului nou",
    "en": "The price of a new device",
    "kz": "Жаңа құрылғының бағасы",
    "ua": "Ціна нового пристрою",
    "pl": "Wycena nowego urządzenia",
    "ge": "ახალი მოწყობილობის ღირებულება",
    "az": "Yeni cihazın qiyməti",
    "": ""
  },
  "tiw__calculatedDevice__price_list_tradeInSale": {
    "key": "tiw__calculatedDevice__price_list_tradeInSale",
    "ru": "Скидка в Trade-In",
    "ro": "Reducere Trade-in",
    "en": "Trade-In sale",
    "kz": "Trade-in-гі жеңілдік",
    "ua": "Вигода у Trade-In",
    "pl": "Sprzedaż w ramach odkupu",
    "ge": "ფასდაკლება Trade-in-ის შემთხვევაში",
    "az": "Trade-in endrimi",
    "": ""
  },
  "tiw__calculatedDevice__price_list_tradeInSale_from": {
    "key": "tiw__calculatedDevice__price_list_tradeInSale_from",
    "ru": "от [[PRICE]] [[CURRENCY]]",
    "ro": "de la [[PRICE]] [[CURRENCY]]",
    "en": "from [[PRICE]] [[CURRENCY]]",
    "kz": "[[PRICE]] [[CURRENCY]] бастап",
    "ua": "від [[PRICE]] [[CURRENCY]]",
    "pl": "od [[PRICE]] [[CURRENCY]]",
    "ge": "[[PRICE]] [[CURRENCY]]-დან",
    "az": "[[PRICE]] [[CURRENCY]] başlayaraq",
    "": ""
  },
  "tiw__calculatedDevice__price_list_tradeInSale_until": {
    "key": "tiw__calculatedDevice__price_list_tradeInSale_until",
    "ru": "до [[PRICE]] [[CURRENCY]]",
    "ro": "până la  [[PRICE]] [[CURRENCY]]",
    "en": "until [[PRICE]] [[CURRENCY]]",
    "kz": "[[PRICE]] [[CURRENCY]] дейін",
    "ua": "до [[PRICE]] [[CURRENCY]]",
    "pl": "do [[PRICE]] [[CURRENCY]]",
    "ge": "[[PRICE]] [[CURRENCY]]-მდე",
    "az": "[[PRICE]] [[CURRENCY]] kimi",
    "": ""
  },
  "tiw__calculatedDevice__price_list_additionalSale": {
    "key": "tiw__calculatedDevice__price_list_additionalSale",
    "ru": "Экстра-бонус за покупку в Trade-in",
    "ro": "Bonus suplimentar pentru achiziția prin Trade-in",
    "en": "Extra bonus for buying in Trade-in",
    "kz": "Trade-in-де сатып алу үшін экстра-бонус",
    "ua": "Екстра-бонус за покупку в Trade-in",
    "pl": "Dodatkowy bonus za zakup w ramach odkupu",
    "ge": "დამატებითი ბონუსი Trade-in-ით შეძენისთვის",
    "az": "Trade-in-də alış üçün əlavə bonus",
    "": ""
  },
  "tiw__calculatedDevice__price_list_additionalSale_valid": {
    "key": "tiw__calculatedDevice__price_list_additionalSale_valid",
    "ru": "Действует с [[START]] до [[END]]",
    "ro": "Este valid de la [[START]] până la [[END]]",
    "en": "Valid from [[START]] to [[END]]",
    "kz": "[[START]] бастап [[END]] дейін жарамды",
    "ua": "Діє з [[START]] до [[END]]",
    "pl": "Obowiązuje od [[START]] do [[END]].",
    "ge": "მოქმედებს [[START]]-დან [[END]]-მდე",
    "az": "[[START]] tarixindən [[END]] tarixinə qədər etibarlıdır",
    "": ""
  },
  "tiw__calculatedDevice__price_list_tradeInInfo": {
    "key": "tiw__calculatedDevice__price_list_tradeInInfo",
    "ru": "Эта сумма определена на основании ваших ответов и является предварительной. Вы узнаете точный размер скидки, как только устройство проверит наш эксперт. В 86% случаев финальная оценка совпадает с предварительной.",
    "ro": "Această sumă este determinată pe baza răspunsurilor Dvs și este preliminară. Veți afla valoarea exactă a reducerii după ce dispozitivul va fi verificat de expertul nostru. În 86% din cazuri, evaluarea finală corespunde cu cea preliminară",
    "en": "This amount is determined based on your answers and is preliminary. You will find out the exact discount amount as soon as our expert checks the device. In 86% of cases, the final assessment coincides with the preliminary one.",
    "kz": "ұл сома сіздің жауаптарыңыз негізінде анықталады және алдын ала баға болып табылады. Жеңілдіктің нақты мөлшерін біздің сарапшы текесергеннен кейін білетін боласыз. 86% жағдайда соңғы бағалау алдын ала бағалаумен сәйкес келеді.",
    "ua": "Ця сума визначена на підставі ваших відповідей та є попередньою. Ви дізнаєтесь точний розмір вигоди, як тільки пристрій перевірить наш експерт. У 86% випадків фінальна оцінка збігається з попередньою.",
    "pl": "Kwota ta jest określana na podstawie udzielonych odpowiedzi i ma charakter wstępny. Dokładną kwotę odkupu poznasz, gdy tylko nasz ekspert sprawdzi urządzenie. W 86% przypadków ostateczna wycena pokrywa się z wyceną wstępną.",
    "ge": "ეს თანხა დგინდება თქვენი პასუხების მიხედვით და არის წინასწარი. ზუსტი ფასდაკლების ოდენობას გაიგებთ მას შემდეგ, რაც ჩვენი ექსპერტი შეამოწმებს მოწყობილობას. 86%-ში საბოლოო შეფასება ემთხვევა წინასწარს.",
    "az": "Bu məbləğ sizin cavablarınız əsasında müəyyən edilir və ilkindir. Ekspertimiz cihazı yoxladıqdan sonra endirimin dəqiq məbləğini biləcəksiniz. 86% hallarda yekun qiymətləndirmə ilkin qiymətləndirmə ilə üst-üstə düşür.",
    "": ""
  },
  "tiw__loadPanel__downloadPhoto": {
    "key": "tiw__loadPanel__downloadPhoto",
    "ru": "Загрузить фото",
    "ro": "Incărcare fotografiei",
    "en": "Upload a photo",
    "kz": "Фотоны жүктеу",
    "ua": "Завантажити фото",
    "pl": "Prześlij zdjęcie",
    "ge": "ატვირთე ფოტო",
    "az": "Foto yükləyin",
    "": ""
  },
  "tiw__loadPanel__downloadPhoto_err": {
    "key": "tiw__loadPanel__downloadPhoto_err",
    "ru": "Загрузите фото",
    "ro": "Incărcare fotografiei",
    "en": "Upload a photo",
    "kz": "Фотосуретті жүктеңіз",
    "ua": "Завантажте фото",
    "pl": "Prześlij zdjęcie",
    "ge": "ატვირთე ფოტო",
    "az": "Foto yükləyin",
    "": ""
  },
  "tiw__loadPanel__downloadPhoto_ambiguous": {
    "key": "tiw__loadPanel__downloadPhoto_ambiguous",
    "ru": "Чтобы уточнить грейд сделайте дополнительные фото",
    "ro": "Pentru a clarifica gradul, faceți fotografii suplimentare",
    "en": "To clarify the grade, take additional photos",
    "kz": "Грейдті нақтылау үшін қосымша фотосуреттер түсіріңіз",
    "ua": "Щоб уточнити грейд, зробіть додаткові фото",
    "pl": "Aby doprecyzować ocenę, zrób dodatkowe zdjęcia",
    "ge": "გადაიღეთ დამატებითი ფოტოები, რათა დავაზუსტოთ მდგომარეობა",
    "az": "Qiyməti aydınlaşdırmaq üçün əlavə fotoşəkillər çəkin",
    "": ""
  },
  "tiw__loadPanel__downloadPhoto_badQuality": {
    "key": "tiw__loadPanel__downloadPhoto_badQuality",
    "ru": "Фото плохого качества",
    "ro": "Fotografie de calitate slabă",
    "en": "Photos of poor quality",
    "kz": "Сапасыз фотосурет",
    "ua": "Фото поганої якості",
    "pl": "Zdjęcia niskiej jakości",
    "ge": "ცუდი ხარისხის ფოტოები",
    "az": "Keyfiyyətsiz şəkil",
    "": ""
  },
  "tiw__loadPanel__downloadPhoto_irrelevant": {
    "key": "tiw__loadPanel__downloadPhoto_irrelevant",
    "ru": "Фото не соответствует требованию",
    "ro": "Fotografie nu corespunde cerințelor",
    "en": "Photos is irrelevant",
    "kz": "Фото талапқа сәйкес келмейді",
    "ua": "Фото не відповідає вимогам",
    "pl": "Zdjęcia nie spełniają wymagań",
    "ge": "ფოტოები არ არის შესაბამისი",
    "az": "Foto tələblərə cavab vermir",
    "": ""
  },
  "tiw__qrPanel__title": {
    "key": "tiw__qrPanel__title",
    "ru": "QR для загрузки с телефона",
    "ro": "QR pentru încărcare de pe telefon",
    "en": "QR code to upload photos from your phone",
    "kz": "Телефоннан жүктеуге арналған QR",
    "ua": "QR для завантаження з телефону",
    "pl": "Kod QR aby przesłać z telefonu",
    "ge": "QR კოდი ტელეფონიდან ჩამოსატვირთად",
    "az": "Telefondan yükləmək üçün QR",
    "": ""
  },
  "tiw__qrPanel__info": {
    "key": "tiw__qrPanel__info",
    "ru": "Если у вас нет фото сдаваемого устройства, отсканируйте QR-код камерой телефона и загрузите их для продолжения заявки.",
    "ro": "Dacă nu aveți fotografii ale dispozitivului predat, scanați codul QR cu camera telefonului și încărcați-le pentru a continua cererea",
    "en": "You can scan the QR code using another phone of yours. Once the photos are uploaded from the phone, you can proceed with assessment here",
    "kz": "Ол үшін телефоныңыздан  QR кодты сканерлеңіз. Фотосуреттер телефоннан жүктелген кезде, Сіз өтінішті рәсімдеуді жалғастыра аласыз.",
    "ua": "Якщо у вас немає фото пристрою, який здається, відскануйте QR-код камерою телефону і завантажте їх для продовження заявки.",
    "pl": "Aby to zrobić, zeskanuj kod QR telefonem. Po przesłaniu zdjęć z telefonu można kontynuować proces odkupu.",
    "ge": "ამისთვის, დაასკანერეთ QR კოდი თქვენი ტელეფონით. მას შემდეგ, რაცფოტოები აიტვირთება, შეგიძლიათ გააგრძელოთ აპლიკაციის რეგისტრაცია.",
    "az": "Əgər alınan cihazın şəkli yoxdursa, telefonunuzun kamerası ilə QR kodunu skan edin və tətbiqinizi davam etdirmək üçün onları yükləyin.",
    "": ""
  },
  "tiw__buyDevice__title": {
    "key": "tiw__buyDevice__title",
    "ru": "Какое устройство вы хотите купить?",
    "ro": "Ce dispozitiv doriți să cumpărați?",
    "en": "Which device do you want to buy?",
    "kz": "Сіз қандай құрылғыны сатып алғыңыз келеді?",
    "ua": "Який пристрій ви хочете купити?",
    "pl": "Jakie urządzenie chcesz kupić?",
    "ge": "რომელი მოწყობილობის ყიდვა გსურთ?",
    "az": "Hansı cihazı almaq istəyirsiniz?",
    "": ""
  },
  "tiw__buyDevice__subtitle": {
    "key": "tiw__buyDevice__subtitle",
    "ru": "Выберите желаемую модель",
    "ro": "Alegeți modelul dorit",
    "en": "Select the desired model",
    "kz": "Қажетті модельді таңдаңыз",
    "ua": "Оберіть бажану модель",
    "pl": "Wybierz model",
    "ge": "აირჩიე სასურველი მოდელი",
    "az": "İstədiyiniz modeli seçin",
    "": ""
  },
  "tiw__buyDevice__brand": {
    "key": "tiw__buyDevice__brand",
    "ru": "Бренд",
    "ro": "Brand",
    "en": "Brand",
    "kz": "Бренд",
    "ua": "Бренд",
    "pl": "Marka",
    "ge": "ბრენდი",
    "az": "Brend",
    "": ""
  },
  "tiw__buyDevice__category": {
    "key": "tiw__buyDevice__category",
    "ru": "Категория",
    "ro": "Categorie",
    "en": "Category",
    "kz": "Санат",
    "ua": "Категорія",
    "pl": "Kategoria",
    "ge": "კატეგორია",
    "az": "Kateqoriya",
    "": ""
  },
  "tiw__buyDevice__model": {
    "key": "tiw__buyDevice__model",
    "ru": "Модель",
    "ro": "Model",
    "en": "Model",
    "kz": "Үлгі",
    "ua": "Модель",
    "pl": "Model",
    "ge": "მოდელი",
    "az": "Model",
    "": ""
  },
  "tiw__chooseDevice__title": {
    "key": "tiw__chooseDevice__title",
    "ru": "Какое устройство вы хотите сдать?",
    "ro": "Ce dispozitiv doriți să predați?",
    "en": "Which device do you want to donate?",
    "kz": "Қандай құрылғыны өткізгіңіз келеді?",
    "ua": "Який пристрій ви хочете здати?",
    "pl": "Które urządzenie chcesz odsprzedać?",
    "ge": "რომელი მოწყობილობის ჩაბარება გსურთ?",
    "az": "Hansı cihazı təhvil vermək istərdiniz?",
    "": ""
  },
  "tiw__chooseDevice__subtitle": {
    "key": "tiw__chooseDevice__subtitle",
    "ru": "Укажите модель, чтобы узнать размер скидки",
    "ro": "Indicați modelul pentru a afla reducere",
    "en": "Specify the model to find out the discount amount",
    "kz": "Жеңілдік мөлшерін білу үшін моделін көрсетіңіз",
    "ua": "Вкажіть модель, щоб дізнатися розмір вигоди",
    "pl": "Określ model, aby dowiedzieć się jaka będzie całkowita zniżka",
    "ge": "მიუთითე მოდელი ფასდაკლების ოდენობის დასადგენად",
    "az": "Endirim məbləğini öyrənmək üçün modeli göstərin",
    "": ""
  },
  "tiw__chooseDevice__subtitle_takealot": {
    "key": "tiw__chooseDevice__subtitle_takealot",
    "ru": "",
    "ro": "",
    "en": "Specify the model to find out the Trade in Amount",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__chooseDevice__brand": {
    "key": "tiw__chooseDevice__brand",
    "ru": "Бренд",
    "ro": "Brand",
    "en": "Brand",
    "kz": "Бренд",
    "ua": "Бренд",
    "pl": "Marka",
    "ge": "ბრენდი",
    "az": "Brend",
    "": ""
  },
  "tiw__chooseDevice__category": {
    "key": "tiw__chooseDevice__category",
    "ru": "Категория",
    "ro": "Categorie",
    "en": "Category",
    "kz": "Санат",
    "ua": "Категорія",
    "pl": "Kategoria",
    "ge": "კატეგორია",
    "az": "Kateqoriya",
    "": ""
  },
  "tiw__chooseDevice__model": {
    "key": "tiw__chooseDevice__model",
    "ru": "Модель",
    "ro": "Model",
    "en": "Model",
    "kz": "Үлгі",
    "ua": "Модель",
    "pl": "Model",
    "ge": "მოდელი",
    "az": "Model",
    "": ""
  },
  "tiw__chooseDevice__other": {
    "key": "tiw__chooseDevice__other",
    "ru": "Память / Модель / Год",
    "ro": "Memorie/ Model/ An",
    "en": "Memory / Model / Year",
    "kz": "Жад / Өлшемі / Жылы",
    "ua": "Пам'ять / Модель / Рік",
    "pl": "Pamięć / Model / Rok",
    "ge": "მეხსიერება / მოდელი / წელი",
    "az": "Yaddaş / Model / İl",
    "": ""
  },
  "tiw__chooseDevice__color": {
    "key": "tiw__chooseDevice__color",
    "ru": "Цвет",
    "ro": "Culoarea",
    "en": "Color",
    "kz": "Түсі",
    "ua": "Колір",
    "pl": "Kolor",
    "ge": "ფერი",
    "az": "Rəng",
    "": ""
  },
  "tiw__chooseDevice__terms": {
    "key": "tiw__chooseDevice__terms",
    "ru": "Больше информации вы найдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\">Условиях использования Breezy Trade-In</a>.",
    "ro": "Mai multe informații puteți găsi în <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\"> Condițiile de utilizare Breezy Trade-In</a>.",
    "en": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\">Breezy Trade-In Terms of Uses </a>.",
    "kz": "<a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\">Қосымша ақпаратты Breezy Trade-In</a> пайдалану шарттарынан таба аласыз.",
    "ua": "Більше інформації ви знайдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\">Умовах використання Breezy Trade-In</a>.",
    "pl": "Więcej informacji można znaleźć w <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/pl.pdf\">Regulamin Odkupu Breezy</a>.",
    "ge": "დამატებით ინფორმაციას იხილავთ <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\">Breezy Trade-In Terms of Uses-ში </a>.",
    "az": "Ətraflı məlumat üçün <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\">Breezy Trade-In İstifadə Şərtlərinə</a> baxın.",
    "": ""
  },
  "tiw__chooseDevice_deviceNotAccepted": {
    "key": "tiw__chooseDevice_deviceNotAccepted",
    "ru": "К сожалению данное устройство не принимается",
    "ro": "Din păcate, acest dispozitiv nu este acceptat",
    "en": "Unfortunately, this device is not accepted",
    "kz": "Бұл құрылғыны қабылдауға жатпайды",
    "ua": "На жаль цей пристрій не приймається",
    "pl": "Niestety, nie możemy zaakceptować tego urządzenia",
    "ge": "სამწუხაროდ, ამ მოწყობილობის მიღება არ არის შესაძლებელი",
    "az": "Təəssüf ki, bu cihaz qəbul edilmir.",
    "": ""
  },
  "tiw__howYouRateDevice__howGetSale": {
    "key": "tiw__howYouRateDevice__howGetSale",
    "ru": "Как получить скидку",
    "ro": "Cum de primit reducere",
    "en": "How to get a discount",
    "kz": "Жеңілдікті қалай алуға болады",
    "ua": "Як отримати вигоду",
    "pl": "Jak uzyskać zniżkę",
    "ge": "როგორ მივიღო ფასდაკლება",
    "az": "Necə endirim əldə etmək olar",
    "": ""
  },
  "tiw__howYouRateDevice__howGetSale_info": {
    "key": "tiw__howYouRateDevice__howGetSale_info",
    "ru": "Вы сможете воспользоваться скидкой, как только подтвердите оценку устройства. Для этого нужно сфотографировать сдаваемый гаджет. Это займет до 5 минут.",
    "ro": "Veți putea beneficia de reducere imediat ce confirmați evaluarea dispozitivului. Pentru aceasta, trebuie să fotografiați gadgetul pe care îl predați. Va dura până la 5 minute",
    "en": "You will be able to take advantage of the discount as soon as you confirm the evaluation of the device. To do this, you need to take a picture of the gadget being handed over. It will take up to 5 minutes.",
    "kz": "Сіз құрылғының бағасын растағаннан кейін жеңілдікті пайдалана аласыз. Мұны істеу үшін өткізілетін гаджетті суретке түсіруіңіз керек. Бұл 5 минут уақытты алады.",
    "ua": "Ви зможете скористатися вигодою, коли підтвердите оцінку пристрою. Для цього потрібно сфотографувати гаджет, що здається. Це триватиме до 5 хвилин.",
    "pl": "Będziesz mógł skorzystać z rabatu, gdy tylko potwierdzisz wycenę urządzenia. W tym celu należy zrobić zdjęcie przekazywanego urządzenia. Zajmie to do 5 minut.",
    "ge": "შეგეძლებათ ისარგებლო ფასდაკლებით მას შემდეგ, რაც დაადასტურებთ მოწყობილობის შეფასებას. ამისთვის ჩასაბარებელ მოწყობილობას უნდა გადაუღოთ ფოტო. ეს პროცესი 5 წუთზე მეტს არ წაიღებს.",
    "az": "Cihazın vəziyyətini təsdiqlədikdən sonra endirimdən yararlana biləcəksiniz. Bunun üçün təhvil verdiyiniz qadcetin şəklini çəkməlisiniz. Bu 5 dəqiqəyə qədər vaxt aparacaq.",
    "": ""
  },
  "tiw__howYouRateDevice__howGetSale_info_goShop": {
    "key": "tiw__howYouRateDevice__howGetSale_info_goShop",
    "ru": "Чтобы воспользоваться скидкой и сдать свое устройство в Trade-In, необходимо прийти в магазин. Устройство будет оценено на месте, после чего вам предоставят скидку на новую покупку.",
    "ro": "Pentru a beneficia de reducere și a preda dispozitivul dvs. prin Trade-In, este necesar să vă prezentați în magazin. Dispozitivul va fi evaluat la fața locului, după care vi se va oferi o reducere pentru noua achiziție",
    "en": "To take advantage of the discount and hand over your device to the Trade-In, you need to come to the store. The device will be evaluated on the spot, after which you will be given a discount on a new purchase.",
    "kz": "Жеңілдікті пайдалану және құрылғыны Trade-In-ге өткізу үшін дүкенге келу керек. Құрылғы сол жерде бағаланады, содан кейін сізге жаңа сатып алуға жеңілдік беріледі.",
    "ua": "Щоб скористатися вигодою та здати свій пристрій у Trade-In, необхідно прийти до магазину. Пристрій буде оцінено на місці, після чого ви сможете використати вигоду при купівлі нового пристрою",
    "pl": "Aby skorzystać z rabatu i oddać urządzenie do odkupu, należy udać się do sklepu. Urządzenie zostanie wycenione na miejscu, po czym otrzymasz rabat na zakup nowego sprzętu.",
    "ge": "ფასდაკლების მისაღებად უნდა მიხვიდეთ მაღაზიაში და ჩააბაროთ მოწყობილობა Trade-In-ში. მოწყობილობა ადგილზე შეფასდება, რის შემდეგაც, მიიღებთ ფასდაკლებას ახალ მოწყობილობაზე.",
    "az": "Endirimdən yararlanmaq və cihazınızı dəyişdirmək üçün mağazaya gəlməlisiniz. Cihaz yerində qiymətləndiriləcək, bundan sonra sizə yeni alışda endirim olunacaq.",
    "": ""
  },
  "tiw__howYouRateDevice__warningNotification__minOrder": {
    "key": "tiw__howYouRateDevice__warningNotification__minOrder",
    "ru": "Обратите внимание, что цена сдаваемого устройства выше, чем цена покупаемого. На цену нового устройства будет применена максимально возможная скидка.",
    "ro": "Vă rugăm să rețineți că prețul dispozitivului predat este mai mare decât prețul dispozitivului achiziționat. Prețul noului dispozitiv va include reducerea maximă posibilă",
    "en": "Please note that price of the trade-in device is higher than the price of purchased device. Maximum possible discount will be applied to the price of the new device.",
    "kz": "Жалға берілетін құрылғының бағасы сатып алынатын құрылғының бағасынан жоғары екеніне назар аударыңыз. Жаңа құрылғының бағасына мүмкін болатын ең жоғары жеңілдік қолданылады.",
    "ua": "Зверніть увагу, що розмір вигоди за Trade-in не може бути більшим, ніж 99% ціни нового пристрою",
    "pl": "Należy pamiętać, że wartość odkupionego urządzenia jest wyższa niż cena zakupionego urządzenia. Maksymalny możliwy rabat zostanie zastosowany do ceny nowego urządzenia.",
    "ge": "გთხოვთ გაითვალისწინოთ: Trade-in მოწყობილობის ფასი შესაძლოა აღემატებოდეს შენაძენის ფასს. მაქსიმალური ფასდაკლება გამოყენებული იქნება ახალი მოწყობილობის ფასზე.",
    "az": "Nəzərə alın ki, geri qaytarılan cihazın qiyməti alınan cihazın qiymətindən yüksəkdir. Yeni cihazın qiymətinə maksimum mümkün endirim tətbiq olunacaq.",
    "": ""
  },
  "tiw__enterImei__title": {
    "key": "tiw__enterImei__title",
    "ru": "Введите IMEI сдаваемого устройства",
    "ro": "Introduceți IMEI-ul dispozitivului predat",
    "en": "Enter the IMEI of the device you are handing over",
    "kz": "Өткізілетін құрылғының IMEI енгізіңіз",
    "ua": "Введіть IMEI пристрою, що здається",
    "pl": "Wprowadź IMEI odsprzedawanego urządzenia",
    "ge": "შეიყვანეთ ჩასაბარებელი მოწყობილობის IMEI",
    "az": "Alış cihazın IMEI-ni daxil edin",
    "": ""
  },
  "tiw__enterImei__imei": {
    "key": "tiw__enterImei__imei",
    "ru": "IMEI",
    "ro": "IMEI",
    "en": "IMEI",
    "kz": "IMEI",
    "ua": "IMEI",
    "pl": "IMEI",
    "ge": "IMEI",
    "az": "IMEI",
    "": ""
  },
  "tiw__enterImei__status": {
    "key": "tiw__enterImei__status",
    "ru": "Идет проверка IMEI, до 60 секунд ожидания...",
    "ro": "Se verifică IMEI-ul, vă rugăm să așteptați până la 60 de secunde...",
    "en": "The IMEI is being checked, up to 60 seconds of waiting...",
    "kz": "IMEI тексерісі 60 секундқа дейін күтіледі...",
    "ua": "Триває перевірка IMEI, до 60 секунд очікування...",
    "pl": "Sprawdzamy numer IMEI, prosimy o chwilę cierpliwości",
    "ge": "მიმდინარეობს IMEI-ს შემოწმება, დაახლოებით 1 წუთამდე დასჭირდება...",
    "az": "IMEI yoxlanışı davam edir, 60 saniyəyə qədər gözləmə...",
    "": ""
  },
  "tiw__enterImei__imei_notAccepted": {
    "key": "tiw__enterImei__imei_notAccepted",
    "ru": "К сожалению данное устройство не принимается",
    "ro": "Din păcate, acest dispozitiv nu este acceptat",
    "en": "Unfortunately, this device is not accepted",
    "kz": "Бұл құрылғыны қабылдауға жатпайды",
    "ua": "На жаль цей пристрій не приймається",
    "pl": "Niestety, nie możemy zaakceptować tego urządzenia",
    "ge": "სამწუხაროდ, ეს მოწყობილობა არ მიიღება",
    "az": "Təəssüf ki, bu cihaz qəbul edilmir.",
    "": ""
  },
  "tiw__enterImei__imei_uncorrect": {
    "key": "tiw__enterImei__imei_uncorrect",
    "ru": "Проверьте правильность ввода IMEI",
    "ro": "Vă rugăm să verificați corectitudinea introducerii codului IMEI",
    "en": "Check that the IMEI is entered correctly",
    "kz": "IMEI енгізуінің дұрыстығын тексеріңіз",
    "ua": "Перевірте правильність введення IMEI",
    "pl": "Sprawdź, czy IMEI został wprowadzony poprawnie",
    "ge": "შეამოწმეთ სწორადაა თუ არა შეყვანილი IMEI",
    "az": "IMEI-nin düzgün daxil olub-olmadığını yoxlayın",
    "": ""
  },
  "tiw__enterImei__imei_reEvaluate": {
    "key": "tiw__enterImei__imei_reEvaluate",
    "ru": "Пожалуйста, перепройдите оценку, выбрав правильную модель",
    "ro": "Vă rugăm să refaceți evaluarea, selectând modelul corect",
    "en": "Please re-evaluate by choosing the correct model",
    "kz": "Дұрыс үлгіні таңдау арқылы бағалауды қайталаңыз",
    "ua": "Будь ласка, перепройдіть оцінку, вибравши правильну модель",
    "pl": "Sprawdź ponownie, wybierając prawidłowy model",
    "ge": "გთხოვთ, თავიდან შეაფასეთ სწორი მოდელის არჩევის შემდეგ",
    "az": "Düzgün modeli seçərək yenidən qiymətləndirin.",
    "": ""
  },
  "tiw__enterImei__imei_foundSignedContract_title": {
    "key": "tiw__enterImei__imei_foundSignedContract_title",
    "ru": "Это устройство уже было оценено",
    "ro": "Dispozitivul acesta deja a fost evaluat",
    "en": "This device has already been rated",
    "kz": "Бұл құрылғы қазірдің өзінде бағаланды",
    "ua": "Цей пристрій вже було оцінено",
    "pl": "To urządzenie było już wycenione",
    "ge": "ეს მოწყობილობა უკვე შეფასებულია",
    "az": "Bu cihaz artıq qiymətləndirilib",
    "": ""
  },
  "tiw__enterImei__imei_foundSignedContract_text": {
    "key": "tiw__enterImei__imei_foundSignedContract_text",
    "ru": "Это устройство уже было оценено на <span class=\"tiw_fw-700\">[[PRICE]] [[CURRENCY]]</span>. Применить эту же оценку?",
    "ro": "Acest dispozitiv a fost deja evaluat pe <span class=\"tiw_fw-700\">[[PRICE]] [[CURRENCY]]</span>. Doriți să aplicați aceeași evaluare?",
    "en": "This device has already been rated at <span class=\"tiw_fw-700\">[[PRICE]] [[CURRENCY]]</span>. Apply the same rating?",
    "kz": "Бұл құрылғы қазірдің өзінде <span class=\"tiw_fw-700\">[[PRICE]] [[CURRENCY]]</span> бағаланды. Осы бағалауды қолдану керек пе?",
    "ua": "Цей пристрій вже був оцінений на <span class=\"tiw_fw-700\">[[PRICE]] [[CURRENCY]]</span>. Застосувати цю оцінку?",
    "pl": "To urządzenie zostało już wycenione na <span class=\"tiw_fw-700\">[[PRICE]] [[CURRENCY]]</span>. Czy zastosować tę samą wycenę?",
    "ge": "მოწყობილობა უკვე შეფასდა: <span class=\"tiw_fw-700\">[[PRICE]] [[CURRENCY]]</span>. მივანიჭოთ იგივე შეფასება?",
    "az": "Bu cihaz artıq <span class=\"tiw_fw-700\">[[PRICE]] [[CURRENCY]]</span> səviyyəsində qiymətləndirilib. Eyni qiymətləndirmə tətbiq olunur?",
    "": ""
  },
  "tiw__step__enterImei__warn__deviceTerminated": {
    "key": "tiw__step__enterImei__warn__deviceTerminated",
    "ru": "Устройство уже было оценено ранее и добавлено к заказу. Повторная оценка не может быть произведена.",
    "ro": "Acest dispozitiv a fost deja evaluat anterior și adăugat la comandă. Reevaluarea nu poate fi efectuată.",
    "en": "The device has already been evaluated earlier and added to the order. Re-evaluation can not be made.",
    "kz": "Құрылғы бұрын бағаланған және тапсырысқа қосылған. Қайта бағалау мүмкін емес.",
    "ua": "Пристрій було оцінено раніше і додано до замовлення. Повторна оцінка не може бути проведена.",
    "pl": "Urządzenie zostało już wcześniej wycenione i dodane do zamówienia. Nie można dokonać ponownej wyceny.",
    "ge": "მოწყობილობა უკვე შეყვანილია შეკვეთაში და ხელმეორედ ვერ შეფასდება.",
    "az": "Cihaz artıq əvvəllər qiymətləndirilib və sifarişə əlavə edilib. Yenidən qiymətləndirmə aparıla bilməz.",
    "": ""
  },
  "tiw__enterImei__imei_foundSignedContract_re_evaluate": {
    "key": "tiw__enterImei__imei_foundSignedContract_re_evaluate",
    "ru": "Оценить заново",
    "ro": "Re-evaluați",
    "en": "Re-evaluate",
    "kz": "Қайта бағалау",
    "ua": "Оцінити заново",
    "pl": "Wyceń ponownie",
    "ge": "ხელმეორედ შეფასება",
    "az": "Yenidən qiymətləndirin",
    "": ""
  },
  "tiw__enterImei__imei_foundSignedContract_apply_evaluate": {
    "key": "tiw__enterImei__imei_foundSignedContract_apply_evaluate",
    "ru": "Применить",
    "ro": "Aplică",
    "en": "Apply",
    "kz": "Қолдану",
    "ua": "Застосувати",
    "pl": "Zastosuj",
    "ge": "დადასტურება",
    "az": "Tətbiq elə",
    "": ""
  },
  "tiw__enterImei__yourModel": {
    "key": "tiw__enterImei__yourModel",
    "ru": "Модель вашего устройства",
    "ro": "Modelul dispozitivului dvs",
    "en": "The model of your device",
    "kz": "Құрылғының моделі",
    "ua": "Модель вашого пристрою",
    "pl": "Model urządzenia",
    "ge": "თქვენი მოწყობილობის მოდელი",
    "az": "Cihazınızın modeli",
    "": ""
  },
  "tiw__enterImei__howFindImei": {
    "key": "tiw__enterImei__howFindImei",
    "ru": "Как найти IMEI?",
    "ro": "Cum să găsesc IMEI?",
    "en": "How to find IMEI?",
    "kz": "IMEI қалай табуға болады?",
    "ua": "Як знайти IMEI?",
    "pl": "Jak znaleźć numer IMEI?",
    "ge": "როგორ ვიპოვო IMEI?",
    "az": "IMEI-ni necə tapmaq olar?",
    "": ""
  },
  "tiw__enterImei__howFindImei_step1": {
    "key": "tiw__enterImei__howFindImei_step1",
    "ru": "Наберите <strong>*#06#</strong> чтобы найти IMEI",
    "ro": "Introduceți IMEI-ul <strong>*#06#</strong>  ca să găsiți IMEI",
    "en": "Dial <strong>*#06#</strong> to find the IMEI",
    "kz": "IMEI табу үшін <strong>*#06#</strong> теріңіз",
    "ua": "Наберіть <strong>*#06#</strong>, щоб знайти IMEI",
    "pl": "Wybierz <strong>*#06#</strong> na klawiaturze telefonu.",
    "ge": "დარეკეთ <strong>*#06#</strong>-ზე, რათა იპოვნოთ IMEI",
    "az": "IMEI tapmaq üçün <strong>*#06#</strong> yığın",
    "": ""
  },
  "tiw__enterImei__howFindImei_step2": {
    "key": "tiw__enterImei__howFindImei_step2",
    "ru": "Или найдите IMEI в настройках устройства",
    "ro": "Sau găsiți IMEI în setări a dispozitivului",
    "en": "Or find the IMEI in the device settings",
    "kz": "Немесе құрылғы баптауларынан IMEI табыңыз",
    "ua": "Або знайдіть IMEI у налаштуваннях пристрою",
    "pl": "Lub znajdź IMEI w ustawieniach urządzenia",
    "ge": "ან მოძებნეთ პარამეტრებში",
    "az": "Və ya cihaz parametrlərində IMEI tapın",
    "": ""
  },
  "tiw__downloadPhotos__title": {
    "key": "tiw__downloadPhotos__title",
    "ru": "Загрузите фото сдаваемого устройства",
    "ro": "Încărcați fotografie a dispozitivului pe care îl predați",
    "en": "Upload photos of the trade-in device",
    "kz": "Өткізілетін құрылғының фотосуретін жүктеңіз",
    "ua": "Завантажте фото пристрою, який здаєте",
    "pl": "Prześlij zdjęcie odsprzedawanego urządzenia",
    "ge": "ატვირთე ჩასაბარებელი მოწყობილობის ფოტო",
    "az": "Trade-in olunan cihazın şəklini yükləyin",
    "": ""
  },
  "tiw__downloadPhotos__title_takealot": {
    "key": "tiw__downloadPhotos__title_takealot",
    "ru": "",
    "ro": "",
    "en": "Upload a photo of the Trade-in device",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__downloadPhotos__qrInfo": {
    "key": "tiw__downloadPhotos__qrInfo",
    "ru": "Используйте фотографии в формате <strong>JPG, BMP, HEIC</strong> или <strong>PNG</strong> с разрешением <strong>72 PPI</strong>. Для быстрой загрузки размер файла не должен превышать <strong>10 МБ</strong>",
    "ro": "Folosiți fotografii în formatul <strong>JPG, BMP, PNG</strong> sau <strong>HEIC</strong> cu o rezoluție de <strong>72 PPI</strong>.Pentru o încărcare rapidă, dimensiunea nu trebuie să depășească <strong>10 MB</strong>",
    "en": "Use photos in the format of <strong>JPG, BMP, PNG</strong> or <strong>HEIC</strong> with a resolution of <strong>72 PPI</strong>. For fast uploading, the file size should not exceed <strong>10 MB</strong>",
    "kz": "<strong>72 PPI</strong> ажыратымдылығы бар <strong>JPG, BMP, HEIC</strong> немесе <strong>PNG</strong> фотосуреттерін пайдаланыңыз. Жылдам жүктеу үшін файл өлшемі <strong>10 МБ</strong> тан аспауы керек.",
    "ua": "Використовуйте фотографії у форматі <strong>JPG, BMP, HEIC</strong> або <strong>PNG</strong> з роздільною здатністю <strong>72 PPI</strong>. Для швидкого завантаження розмір файлу не повинен перевищувати <strong>10 МБ</strong>",
    "pl": "Użyj zdjęć w formacie <strong>JPG, BMP, PNG</strong> lub <strong>HEIC</strong> o rozdzielczości <strong>72 PPI</strong>. W celu szybkiego przesłania rozmiar pliku nie powinien przekraczać <strong>10 MB</strong>.",
    "ge": "გამოიყენეთ შემდეგი ფორმატები: <strong>JPG, BMP, PNG</strong> or <strong>HEIC</strong> რეზოლუციით: <strong>72 PPI</strong>. სწრაფად ატვირთვისათვის, ფოტოს ზომა არ უნდა აღემატებოდეს <strong>10 MB</strong>",
    "az": "<strong>72 PPI</strong> təsvir ölçüsü ilə <strong>JPG, BMP, HEIC</strong> və ya <strong>PNG</strong> formatında fotolardan istifadə edin. Sürətli yükləmə üçün faylın ölçüsü <strong>10 MB</strong>-dən çox olmamalıdır",
    "": ""
  },
  "tiw__operatorExecuting__title_loading": {
    "key": "tiw__operatorExecuting__title_loading",
    "ru": "Подготовка к обработке",
    "ro": "Pregătirea pentru procesare",
    "en": "Preparation for processing",
    "kz": "Өңдеуге дайындық",
    "ua": "Підготовка до обробки",
    "pl": "Przygotowanie do przetwarzania",
    "ge": "დამუშავებისთვის მომზადება",
    "az": "Emal üçün hazırlıq",
    "": ""
  },
  "tiw__operatorExecuting__message_loading": {
    "key": "tiw__operatorExecuting__message_loading",
    "ru": "Фотографии загружены, скоро начнётся оценка",
    "ro": "Fotografiile au fost încărcate, evaluarea va începe în curând",
    "en": "The photos have been uploaded, the evaluation will begin soon",
    "kz": "Фотосуреттер жүктелді, енді бағалау басталады",
    "ua": "Фотографії завантажені, незабаром почнеться оцінка",
    "pl": "Zdjęcia zostały przesłane, ocena rozpocznie się wkrótce",
    "ge": "ფოტოები აიტვირთა, შეფასება მალე დაიწყება",
    "az": "Fotolar yüklənib, giymətləndirmə tezliklə başlayacaq",
    "": ""
  },
  "tiw__operatorExecuting__title_processing": {
    "key": "tiw__operatorExecuting__title_processing",
    "ru": "Идет изучение фотографий",
    "ro": "Fotografiile sunt în proces de evaluare",
    "en": "Photos are being studied",
    "kz": "Фотосуреттерді зерттеу жүріп жатыр",
    "ua": "Йде вивчення фотографій",
    "pl": "Zdjęcia są analizowane",
    "ge": "ფოტოები განხილვაშია",
    "az": "Fotolar araşdırılır",
    "": ""
  },
  "tiw__operatorExecuting__message_processing": {
    "key": "tiw__operatorExecuting__message_processing",
    "ru": "Оценка в процессе, пожалуйста, подождите 2-3 минуты",
    "ro": "Evaluarea este în curs, vă rugăm să așteptați 2-3 minute",
    "en": "Evaluation is in progress, please wait 2-3 minutes",
    "kz": "Бағалау жүріп жатыр, 2-3 минут күтіңіз",
    "ua": "Оцінка в процесі, будь ласка, зачекайте 2-3 хвилини",
    "pl": "Ocena jest w toku, poczekaj 2-3 minuty",
    "ge": "მიმდინარეობს შეფასება, გთხოვთ დაიცადოთ 2-3 წუთი",
    "az": "Qiymətləndirmə aparılır, lütfən, 2-3 dəqiqə gözləyin",
    "": ""
  },
  "tiw__operatorExecuting__title_done": {
    "key": "tiw__operatorExecuting__title_done",
    "ru": "Все фото обработаны",
    "ro": "Toate fotografii sunt procesate",
    "en": "All photos have been processed",
    "kz": "Барлық фотосуреттер өңделді",
    "ua": "Усі фото оброблені",
    "pl": "Wszystkie zdjęcia zostały przetworzone",
    "ge": "ყველა ფოტო დამუშავდა",
    "az": "Bütün fotolar işlənib",
    "": ""
  },
  "tiw__operatorExecuting__message_done": {
    "key": "tiw__operatorExecuting__message_done",
    "ru": "Все фотографии были оценены, результат появится в течение 30 секунд",
    "ro": "Toate fotografiile au fost evaluate, rezultatul va apărea în decurs de 30 de secunde",
    "en": "All photos have been evaluated, the result will appear within 30 seconds",
    "kz": "Барлық фотосуреттер өңделеді, нәтиже 30 секунд ішінде пайда болады",
    "ua": "Усі фотографії оцінені, результат з'явиться протягом 30 секунд",
    "pl": "Wszystkie zdjęcia zostały ocenione, wynik pojawi się w ciągu 30 sekund.",
    "ge": "შეფასება დასრულდა, შედეგი 30 წამში გამოჩნდება",
    "az": "Bütün fotoşəkillər qiymətləndirilib, nəticə 30 saniyə ərzində görünəcək",
    "": ""
  },
  "tiw__operatorExecuting__sorryText": {
    "key": "tiw__operatorExecuting__sorryText",
    "ru": "К сожалению, оценка устройства потребовала больше времени, чем ожидалось. Приносим извинения за возникшие неудобства. Пожалуйста, не закрывайте окно и подождите ещё немного - результат вот-вот появится на экране",
    "ro": "Din păcate, evaluarea dispozitivului a durat mai mult decât era de așteptat. Cerem scuze pentru incomodități. Vă rugăm să nu închideți fereastra și să mai așteptați puțin – rezultatul va apărea imediat pe ecran",
    "en": "Unfortunately, the evaluation of the device took longer than expected. We apologize for any inconvenience. Please do not close the window and wait a little longer - the result is about to appear on the screen",
    "kz": "Өкінішке орай, құрылғыны бағалау күткеннен көп уақытты алды. Туындаған қолайсыздықтар үшін кешірім сұраймыз. Терезені жаппаңыз және тағы біраз күтіңіз - нәтиже экранда пайда болады",
    "ua": "На жаль, оцінка пристрою потребує більше часу, ніж очікувалося. Просимо вибачення за незручності. Будь ласка, не закривайте вікно і зачекайте ще трохи – результат ось-ось з'явиться на екрані",
    "pl": "Niestety ocena urządzenia trwała dłużej niż oczekiwano. Przepraszamy za wszelkie niedogodności. Nie zamykaj okna i poczekaj trochę dłużej - wynik wkrótce pojawi się na ekranie.",
    "ge": "შეფასება მოსალოდნელზე დიდხანს გაგრძელდა. ბოდიშს გიხდით შეფერხებისთვის. გთხოვ არ დახურო ფანჯარა, შედეგი მალე გამოჩნდება",
    "az": "Təəssüf ki, cihazın qiymətləndirilməsi gözləniləndən daha uzun çəkdi. Bunun səbəb ola biləcəyi hər hansı narahatlığa görə üzr istəyirik. Pəncərəni bağlamayın və bir az daha gözləyin - nəticə tezliklə ekranda görünəcək",
    "": ""
  },
  "tiw__evaluationResult__title": {
    "key": "tiw__evaluationResult__title",
    "ru": "Результат оценки",
    "ro": "Rezultatele evaluării",
    "en": "Evaluation result",
    "kz": "Бағалау нәтижесі",
    "ua": "Результат оцінки",
    "pl": "Wynik oceny",
    "ge": "შეფასების შედეგი",
    "az": "Qiymətləndirmə nəticəsi",
    "": ""
  },
  "tiw__evaluationResult__downloadMore": {
    "key": "tiw__evaluationResult__downloadMore",
    "ru": "Дозагрузить фото",
    "ro": "Încărcați fotografii suplimentare",
    "en": "Upload more photos",
    "kz": "Фотоларды қосымша жүктеу",
    "ua": "Дозавантажити фото",
    "pl": "Prześlij więcej zdjęć",
    "ge": "ატვირთე მეტი ფოტო",
    "az": "Foto yükləyin",
    "": ""
  },
  "tiw__successfulEvaluation__title": {
    "key": "tiw__successfulEvaluation__title",
    "ru": "Время узнать цену!",
    "ro": "E timpul sa aflăm prețul!",
    "en": "It's time to find out the price!",
    "kz": "Бағаны білуге уақыт келді!",
    "ua": "Час дізнатися ціну!",
    "pl": "Czas poznać cenę!",
    "ge": "ფასის დადგენის დროა!",
    "az": "Qiyməti öyrənmək vaxtıdır!",
    "": ""
  },
  "tiw__successfulEvaluation__subtitle": {
    "key": "tiw__successfulEvaluation__subtitle",
    "ru": "Теперь вы точно знаете, сколько сэкономите в Trade-In. Осталось подписать договор",
    "ro": "Acum știți exact cât veți economisi prin Trade-In. Rămâne să semnați contractul prin.",
    "en": "Now you know exactly how much you will save in Trade-In. It remains to sign an agreement",
    "kz": "Енді сіз Trade-In-де қанша үнемдейтіндігіңізді білесіз. Шартқа қол қою қалды",
    "ua": "Тепер ви точно знаєте, скільки заощадите у Trade-In. Залишилось підписати договір",
    "pl": "Teraz wiesz dokładnie, ile zaoszczędzisz na wymianie. Pozostaje podpisać umowę, do której link znajdziesz w SMS.",
    "ge": "ახლა უკვე ზუსტად იცი რამდენს დაზოგავ Trade-In-ით. დარჩა მხოლოდ შეთანხმების გაფორმება",
    "az": "İndi siz Trade-In-də nə qədər qənaət edəcəyinizi dəqiq bilirsiniz. Sadəcə müqaviləsini imzalamaq qalır",
    "": ""
  },
  "tiw__successfulEvaluation__imei_title": {
    "key": "tiw__successfulEvaluation__imei_title",
    "ru": "IMEI вашего устройства",
    "ro": "IMEI-ul dispozitivului dvs",
    "en": "IMEI of your device",
    "kz": "Құрылғының IMEI",
    "ua": "IMEI вашого пристрою",
    "pl": "IMEI urządzenia",
    "ge": "თქვენი მოწყობილობის IMEI",
    "az": "Cihazınızın IMEI",
    "": ""
  },
  "tiw__successfulEvaluation__imei": {
    "key": "tiw__successfulEvaluation__imei",
    "ru": "IMEI",
    "ro": "IMEI",
    "en": "IMEI",
    "kz": "IMEI",
    "ua": "IMEI",
    "pl": "IMEI",
    "ge": "IMEI",
    "az": "IMEI",
    "": ""
  },
  "tiw__successfulEvaluation__fio_title": {
    "key": "tiw__successfulEvaluation__fio_title",
    "ru": "Данные для заключения договора",
    "ro": "Datele spre întocmire contractului",
    "en": "Data for the conclusion of the contract",
    "kz": "Шарт жасауға арналған деректер",
    "ua": "Дані для укладання договору",
    "pl": "Dane do zawarcia umowy",
    "ge": "მონაცემები ხელშეკრულების შესავსებად",
    "az": "Müqavilə bağlamaq üçün məlumatlar",
    "": ""
  },
  "tiw__successfulEvaluation__fio": {
    "key": "tiw__successfulEvaluation__fio",
    "ru": "ФИО",
    "ro": "Numele plin",
    "en": "Full name",
    "kz": "ТАӘ",
    "ua": "ПІБ",
    "pl": "Pełna nazwa",
    "ge": "სახელი და გვარი",
    "az": "SAA",
    "": ""
  },
  "tiw__successfulEvaluation__idnp": {
    "key": "tiw__successfulEvaluation__idnp",
    "ru": "Идентификационный номер (ИДНП)",
    "ro": "Număr de identificare (IDNP)",
    "en": "Identification number (IDNP)",
    "kz": "Сәйкестендіру нөмірі (IDNP)",
    "ua": "Ідентифікаційний номер (ІДНП)",
    "pl": "Numer identyfikacyjny (IDNP)",
    "ge": "პირადი ნომერი",
    "az": "Eyniləşdirmə nömrəsi (VÖEN)",
    "": ""
  },
  "tiw__successfulEvaluation__inn": {
    "key": "tiw__successfulEvaluation__inn",
    "ru": "Идентификационный номер (ИНН)",
    "ro": "Număr de identificare (IDNP)",
    "en": "Identification number (INN)",
    "kz": "Сәйкестендіру нөмірі (ЖСН)",
    "ua": "Ідентифікаційний номер (ІПН)",
    "pl": "Numer identyfikacyjny (INN)",
    "ge": "პირადი ნომერი",
    "az": "Eyniləşdirmə nömrəsi (VÖEN)",
    "": ""
  },
  "tiw__successfulEvaluation__documentNumber": {
    "key": "tiw__successfulEvaluation__documentNumber",
    "ru": "Номер удостоверения личности",
    "ro": "Număr de seri buletinului de identitate",
    "en": "Document number",
    "kz": "Жеке куәлік нөмірі",
    "ua": "Номер документа, що підтверджує особу",
    "pl": "Numer dokumentu",
    "ge": "Document number",
    "az": "Şəxsiyyət vəsiqəsinin nömrəsi",
    "": ""
  },
  "tiw__successfulEvaluation__city": {
    "key": "tiw__successfulEvaluation__city",
    "ru": "Город",
    "ro": "Oraș",
    "en": "City",
    "kz": "Қала",
    "ua": "Місто",
    "pl": "Miasto",
    "ge": "ქალაქი",
    "az": "Şəhər",
    "": ""
  },
  "tiw__successfulEvaluation__street": {
    "key": "tiw__successfulEvaluation__street",
    "ru": "Улица",
    "ro": "Strada",
    "en": "Street",
    "kz": "Көше",
    "ua": "Вулиця",
    "pl": "Ulica",
    "ge": "ქუჩა",
    "az": "Küçə",
    "": ""
  },
  "tiw__successfulEvaluation__house": {
    "key": "tiw__successfulEvaluation__house",
    "ru": "Дом",
    "ro": "Casa",
    "en": "House",
    "kz": "Үй",
    "ua": "Будинок",
    "pl": "Numer domu",
    "ge": "სახლი",
    "az": "Ev",
    "": ""
  },
  "tiw__successfulEvaluation__apartment": {
    "key": "tiw__successfulEvaluation__apartment",
    "ru": "Квартира",
    "ro": "Apartament",
    "en": "Apartment",
    "kz": "Пәтер",
    "ua": "Квартира",
    "pl": "Numer mieszkania",
    "ge": "ბინა",
    "az": "Mənzil",
    "": ""
  },
  "tiw__successfulEvaluation__email": {
    "key": "tiw__successfulEvaluation__email",
    "ru": "Email",
    "ro": "Email",
    "en": "Email",
    "kz": "Email",
    "ua": "Email",
    "pl": "E-mail",
    "ge": "ელ. ფოსტა",
    "az": "Email",
    "": ""
  },
  "tiw__successfulEvaluation__phone": {
    "key": "tiw__successfulEvaluation__phone",
    "ru": "Телефон",
    "ro": "Număr de telefon",
    "en": "Phone",
    "kz": "Телефон",
    "ua": "Телефон",
    "pl": "Telefon",
    "ge": "ტელეფონის ნომერი",
    "az": "Telefon",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_personal": {
    "key": "tiw__successfulEvaluation__checkbox_personal",
    "ru": "Я соглашаюсь на обработку моих <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf#personal-data\"> персональных данных </a> и <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\"> условия Trade-In </a>",
    "ro": "Sunt de acord cu procesarea <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf#personal-data\"> datelor mele personale </a> și <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\"> cu condițiile de Trade-In </a>",
    "en": "I agree to the processing of my <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy .band/kz.pdf#personal-data\"> personal data </a> and <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy .band/kz.pdf\"> Trade-In terms </a>",
    "kz": "Мен <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf#personal-data\"> жеке деректерімді </a> және <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\"> cауда шарттары</a>",
    "ua": "Я погоджуюсь на обробку моїх персональних даних</a> та <a class=\"tiw__link tiw__link_theme-light\" target href=\"https://breezy.band/kz.pdf\">умови Trade-In</a>",
    "pl": "Wyrażam zgodę na przetwarzanie moich <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy .band/kz.pdf#personal-data\"> danych osobowych </a> oraz <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy .band/kz.pdf\"> warunków Trade-In </a>.",
    "ge": "ვეთანხმები დამუშავებას ჩემი <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy .band/kz.pdf#personal-data\"> პირადი ინფორმაციისა </a> and <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy .band/kz.pdf\"> Trade-In-ის პირობებს </a>",
    "az": "Mən <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf#personal-data\"> şəxsi məlumatlarımın </a> və <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"-band\" target=\"blank\" href=\"-band\"https://pd.kz/\"-in emalı ilə razıyam. </a>",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_personal__ge": {
    "key": "tiw__successfulEvaluation__checkbox_personal__ge",
    "ru": "Я соглашаюсь на обработку моих <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf#personal-data\"> персональных данных </a> и <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\"> условия Trade-In </a>",
    "ro": "Sunt de acord cu procesarea <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf#personal-data\"> datelor mele personale </a> și <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\"> cu condițiile de Trade-In </a>",
    "en": "I agree to the processing of my <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Personal_Data_Protection_Policy_EN.pdf\"> personal data </a> and <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Customer-Facing-General-T-and-Cs-EN.pdf\"> Trade-In terms </a>",
    "kz": "Мен <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf#personal-data\"> жеке деректерімді </a> және <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf\"> cауда шарттары</a>",
    "ua": "Я погоджуюсь на обробку моїх персональних даних</a> та <a class=\"tiw__link tiw__link_theme-light\" target href=\"https://breezy.band/kz.pdf\">умови Trade-In</a>",
    "pl": "Wyrażam zgodę na przetwarzanie moich <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy .band/kz.pdf#personal-data\"> danych osobowych </a> oraz <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy .band/kz.pdf\"> warunków Trade-In </a>.",
    "ge": "ვეთანხმები დამუშავებას ჩემი <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Personal_Data_Protection_Policy_GE.pdf\"> პირადი ინფორმაციისა </a> and <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Customer-Facing-General-T-and-Cs-GE.pdf\"> Trade-In-ის პირობებს </a>",
    "az": "Mən <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/kz.pdf#personal-data\"> şəxsi məlumatlarımın </a> və <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"-band\" target=\"blank\" href=\"-band\"https://pd.kz/\"-in emalı ilə razıyam. </a>",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_personal__md": {
    "key": "tiw__successfulEvaluation__checkbox_personal__md",
    "ru": "Я соглашаюсь на обработку моих <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Trade-In_Terms_and_Conditions_RU.pdf#10.%20%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5%20%D0%BD%D0%B0%20%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D1%83%20%D0%BF%D0%B5%D1%80%D1%81%D0%BE%D0%BD%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D1%85%20%D0%B4%D0%B0%D0%BD%D0%BD%D1%8B%D1%85.\"> персональных данных </a>",
    "ro": "Sunt de acord cu procesarea <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Trade-In_Terms_and_Conditions_RO.pdf#10.%20Consim%C8%9B%C4%83m%C3%A2ntul%20pentru%20prelucrarea%20datelor%20cu%20caracter%20personal.\"> datelor mele personale </a>",
    "en": "I agree to the processing of my <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy .band/kz.pdf#personal-data\"> personal data </a>",
    "kz": "Мен <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/breezy-m-srl-private-policy.pdf\"> жеке деректерімді </a>",
    "ua": "Я погоджуюсь на обробку моїх <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/breezy-m-srl-private-policy.pdf\"> персональних даних </a>",
    "pl": "Wyrażam zgodę na przetwarzanie moich <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy .band/kz.pdf#personal-data\"> danych osobowych </a> oraz <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy .band/kz.pdf\"> warunków Trade-In </a>",
    "ge": "ვეთანხმები დამუშავებას ჩემი <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy .band/kz.pdf#personal-data\"> პირადი ინფორმაციისა </a>",
    "az": "Mən <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/breezy-m-srl-private-policy.pdf\"> şəxsi məlumatlarımın </a>",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_duty_head": {
    "key": "tiw__successfulEvaluation__checkbox_duty_head",
    "ru": "Я обязуюсь",
    "ro": "Mă oblig",
    "en": "I commit to",
    "kz": "Мен міндеттеймін",
    "ua": "Я зобов'язуюсь",
    "pl": "Zobowiązuję się do",
    "ge": "ვაცნობიერებ და ვადასტურებ, რომ:",
    "az": "öhdəsinə götürürəm",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_duty_step1": {
    "key": "tiw__successfulEvaluation__checkbox_duty_step1",
    "ru": "передать устройство с тем же IMEI, который был указан при оценке;",
    "ro": "să predau dispozitivul cu același IMEI care a fost specificat la evaluare;",
    "en": "transfer the device with the same IMEI that was specified during the evaluation;",
    "kz": "құрылғыны бағалау кезінде көрсетілген бірдей IMEI-мен тапсыру;",
    "ua": "передати пристрій з тим самим IMEI, який був вказаний при оцінці;",
    "pl": "przekazania urządzenia z tym samym numerem IMEI, który został podany podczas oceny;",
    "ge": "ჩავაბარებ მოწყობილობას იმავე IMEI-თ, რაც იქნა მითითებული შეფასების დროს;",
    "az": "cihazı qiymətləndirmə zamanı göstərilən eyni IMEI ilə köçürün;",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_duty_step2": {
    "key": "tiw__successfulEvaluation__checkbox_duty_step2",
    "ru": "передать устройство в том же состоянии, в каком оно было в момент диагностики;",
    "ro": "să predau dispozitivul în aceeași stare în care se afla la momentul diagnosticării;",
    "en": "transfer the device in the same state as it was at the time of diagnosis;",
    "kz": "құрылғыны диагностика кезінде болған күйінде тапсыру;",
    "ua": "передати пристрій у тому стані, в якому він був в момент діагностики;",
    "pl": "przekazania urządzenia w takim samym stanie, w jakim znajdowało się w momencie diagnozy;",
    "ge": "ჩავაბარებ მოწყობილობას იმავე მდგომარეობაში, რაც დაფიქსირდა შეფასებისას;",
    "az": "cihazı diaqnostika zamanı olduğu vəziyyətdə təhvil verin;",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_duty_step3": {
    "key": "tiw__successfulEvaluation__checkbox_duty_step3",
    "ru": "выйти из всех аккаунтов к моменту передачи устройства.",
    "ro": "să ies din toate conturile până la momentul predării dispozitivului",
    "en": "log out of all accounts by the time the device is transferred.",
    "kz": "құрылғыны беру кезінде барлық тіркеулік жазбалардан шығу.",
    "ua": "вийти з усіх облікових записів до моменту передачі пристрою.",
    "pl": "wylogowania się ze wszystkich kont do czasu przekazania urządzenia.",
    "ge": "გამოდით ყველა ანგარიშიდან ჩაბარების მომენტამდე",
    "az": "Cihazı təhvil verməzdən əvvəl bütün hesablardan çıxın.",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_duty_footer": {
    "key": "tiw__successfulEvaluation__checkbox_duty_footer",
    "ru": "Я понимаю, что невыполнение данных условий ведет к аннулированию покупки в Trade-In",
    "ro": "Înțeleg că nerespectarea acestor condiții duce la anularea achiziției prin Trade-In",
    "en": "I understand that failure to comply with these conditions leads to the cancellation of the purchase in the Trade-In",
    "kz": "Мен бұл шарттарды орындамау Trade-In сатып алудан бас тартуға әкелетінін түсінемін",
    "ua": "Я розумію, що невиконання цих умов веде до анулювання покупки у Trade-In.",
    "pl": "Rozumiem, że niespełnienie tych warunków prowadzi do anulowania zakupu w ramach wymiany.",
    "ge": "ვაცნობიერებ, რომ ამ პირობების დარღვევა გამოიწვევს Trade-In-ის გაუქმებას",
    "az": "Mən başa düşürəm ki, bu şərtlərə əməl edilməməsi Trade-In alışının ləğvi ilə nəticələnəcək.",
    "": ""
  },
  "tiw__successfulEvaluation__warn": {
    "key": "tiw__successfulEvaluation__warn",
    "ru": "<strong>Обратите внимание!</strong> Получение заказа только по удостоверению личности.",
    "ro": "<strong>Trageți atenție!</strong> Preluarea comenzii se face doar pe baza actului de identitate.",
    "en": "<strong>Please note!</strong> Receiving an order only with an identity card.",
    "kz": "<strong>Назар аударыңыз!</strong> Тапсырысты тек жеке куәлік бойынша ала аласыз.",
    "ua": "<strong>Зверніть увагу!</strong> Отримання замовлення лише за посвідченням особи.",
    "pl": "<strong>Uwaga! </strong> Otrzymanie zamówienia tylko z dowodem tożsamości.",
    "ge": "<strong>გთხოვთ, გაითვალისწინოთ!</strong> შეკვეთის გაფორმება ხდება მხოლოდ პირადობის დამადასტურებელი დოკუმენტით",
    "az": "<strong>Qeyd edin!</strong> Sifarişin qəbulu yalnız şəxsiyyət vəsiqəsi ilə mümkündür.",
    "": ""
  },
  "tiw__successfulEvaluation__receivingViaSMS": {
    "key": "tiw__successfulEvaluation__receivingViaSMS",
    "ru": "",
    "ro": "",
    "en": "Receiving the contract via SMS",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__successfulEvaluation__toContract": {
    "key": "tiw__successfulEvaluation__toContract",
    "ru": "Получить договор по SMS",
    "ro": "Primiți contractul prin SMS",
    "en": "Get a contract by SMS",
    "kz": "SMS арқылы шарт алу",
    "ua": "Отримати договір по SMS",
    "pl": "Otrzymanie umowy przez SMS",
    "ge": "ხელშეკრულება SMS-ით",
    "az": "SMS vasitəsilə müqavilə alın",
    "": ""
  },
  "tiw__sendSmsContract__title": {
    "key": "tiw__sendSmsContract__title",
    "ru": "Осталось только подписать договор",
    "ro": "A rămas numai să semnați contractul",
    "en": "All that remains is to sign the contract",
    "kz": "Шартқа қол қою ғана қалды",
    "ua": "Залишилось лише підписати договір",
    "pl": "Pozostaje tylko podpisać umowę",
    "ge": "დარჩა მხოლოდ ხელმოწერა",
    "az": "Yalnız müqaviləni imzalamaq qalır",
    "": ""
  },
  "tiw__sendSmsContract__subtitle": {
    "key": "tiw__sendSmsContract__subtitle",
    "ru": "Договор успешно оформлен и ожидает подписания через SMS-сообщение. Для этого нажмите кнопку \"Отправить SMS-договор\"",
    "ro": "Contractul a fost întocmit cu succes și așteaptă semnarea prin SMS. Pentru a face acest lucru, apăsați butonul „Trimite contractul prin SMS”.",
    "en": "The contract has been successfully executed and is awaiting signing via SMS. To do this, click the \"Send SMS agreement\" button",
    "kz": "Шарт сәтті ресімделді және SMS хабарлама арқылы қол қоюды күтуде. Ол үшін \"SMS-шарт жіберу\" батырмасын басыңыз",
    "ua": "Договір успішно оформлений та чекає на підписання через SMS-повідомлення. Для цього натисніть кнопку \"Надіслати SMS-договір\"",
    "pl": "Umowa została pomyślnie przygotowana i oczekuje na podpisanie. Aby to zrobić, kliknij przycisk \"Wyślij umowę SMS\".",
    "ge": "ხელშეკრულება წარმატებით გაფორმდა და ელოდება SMS-ით ხელმოწერას. ამისთვის დააჭირეთ ღილაკს: \"გაგზავნე SMS შეთანხმება\"",
    "az": "Müqavilə uğurla tamamlandı və SMS mesajı vasitəsilə imzalanmanı gözləyir. Bunu etmək üçün \"SMS müqaviləsi göndər\" düyməsini basın",
    "": ""
  },
  "tiw__sendSmsContract__sendContract": {
    "key": "tiw__sendSmsContract__sendContract",
    "ru": "Отправить SMS-договор",
    "ro": "Trimiteți SMS contractul ",
    "en": "Send an SMS contract",
    "kz": "SMS-шартты жіберу",
    "ua": "Надіслати SMS-договір",
    "pl": "Wyślij umowę SMS",
    "ge": "გაგზავნე SMS შეთანხმება",
    "az": "SMS müqavilə göndərin",
    "": ""
  },
  "tiw__addToCart__title": {
    "key": "tiw__addToCart__title",
    "ru": "Ура! Все готово!",
    "ro": "Ura! Totul este gata!",
    "en": "Hurray! Everything is ready!",
    "kz": "Алақай! Барлығы дайын!",
    "ua": "Ура! Все готово!",
    "pl": "Hurra! Wszystko gotowe!",
    "ge": "ურაა! ყველაფერი მზადაა!",
    "az": "Yaşasın! Hər şey hazırdır!",
    "": ""
  },
  "tiw__addToCart__subtitle": {
    "key": "tiw__addToCart__subtitle",
    "ru": "Договор отправлен на номер <strong>[[NUMBER]]</strong> и ожидает Вашего подписания через SMS сообщение. Нажимая на кнопку \"[[TEXT]]\" вы подтверждаете, что подписали договор",
    "ro": "Contractul a fost trimis la număr <strong>[[NUMBER]]</strong> și așteaptă ca DVS să-l semnați prin SMS. Apăsând butonul \"[[TEXT]]\", confirmați că ați semnat contractul",
    "en": "The contract has been successfully sent to the number <strong>[[NUMBER]]</strong> and is awaiting your signing via SMS message. By clicking on the \"[[TEXT]]\" button, you confirm that you have signed the contract",
    "kz": "Шарт <strong>[[NUMBER]]</strong> нөміріне сәтті жіберілді және SMS хабарлама арқылы қол қоюыңызды күтеді. \"[[TEXT]]\" батырмасын басу арқылы сіз шартқа қол қойғаныңызды растайсыз",
    "ua": "Договір відправлений на номер <strong>[[NUMBER]]</strong> і чекає на Ваше підписання через SMS повідомлення. Натискаючи кнопку \"[[TEXT]]\" ви підтверджуєте, що підписали договір",
    "pl": "Umowa została pomyślnie wysłana na numer <strong>[[NUMBER]]</strong> i oczekuje na podpisanie. Klikając przycisk \"[[TEXT]]\", potwierdzasz, że podpisałeś umowę",
    "ge": "ხელშეკრულება წარმატებით გაიგზავნა ნომერზე <strong>[[NUMBER]]</strong> და ელოდება SMS ხელმოწერას. \"[[TEXT]]\" ღილაკზე დაჭერით ადასტურებთ, რომ მოაწერეთ ხელი",
    "az": "Müqavilə <strong>[[NUMBER]]</strong> nömrəsinə göndərilib və SMS mesajı ilə imzanızı gözləyir. \"[[TEXT]]\" düyməsini sıxmaqla siz müqaviləni imzaladığınızı təsdiq edirsiniz",
    "": ""
  },
  "tiw__addToCart__notContract": {
    "key": "tiw__addToCart__notContract",
    "ru": "Не получили договор? Отправьте договор еще раз",
    "ro": "Nu ați primit contractul? Trimiteți contractul din nou.",
    "en": "Have you not received the contract? Send the contract again",
    "kz": "Шартты алмадыңыз ба? Шартты тағы бір рет жіберіңіз",
    "ua": "Не отримали договір? Надішліть договір ще раз",
    "pl": "Nie otrzymałeś umowy? Wyślij umowę ponownie",
    "ge": "არ მიგიღიათ ხელშეკრულება? გააგზავნეთ ხელახლა",
    "az": "Müqaviləni almadınız? Zəhmət olmasa müqaviləni yenidən göndərin.",
    "": ""
  },
  "tiw__addToCart__sendAgain": {
    "key": "tiw__addToCart__sendAgain",
    "ru": "Отправить SMS-договор еще раз",
    "ro": "Trimiteți contractul prin SMS din nou.",
    "en": "Send the SMS contract again",
    "kz": "SMS-шартын тағы бір рет жіберу",
    "ua": "Надіслати SMS-договір ще раз",
    "pl": "Wyślij ponownie umowę SMS-em",
    "ge": "თავიდან გაგზავნეთ SMS ხელშეკრულება",
    "az": "Yenidən SMS müqaviləsi göndərin",
    "": ""
  },
  "tiw__addToCart__warn": {
    "key": "tiw__addToCart__warn",
    "ru": "Договор не был подписан",
    "ro": "Contractul nu a fost semnat",
    "en": "The contract was not signed",
    "kz": "Шартқа қол қойылмаған",
    "ua": "Договір не був підписаний",
    "pl": "Umowa nie została podpisana",
    "ge": "ხელმოწერა არ განხორციელდა",
    "az": "Müqavilə imzalanmayıb",
    "": ""
  },
  "tiw__addToCart__addToCart": {
    "key": "tiw__addToCart__addToCart",
    "ru": "Добавить в корзину",
    "ro": "Adaugă in coș",
    "en": "Add to Cart",
    "kz": "Себетке қосу",
    "ua": "Додати в кошик",
    "pl": "Dodaj do koszyka",
    "ge": "კალათაში დამატება",
    "az": "Səbətə əlavə et",
    "": ""
  },
  "tiw__signingWithoutSms__title": {
    "key": "tiw__signingWithoutSms__title",
    "ru": "Ура! Все готово!",
    "ro": "Ura! Totul este gata!",
    "en": "Hurray! Everything is ready!",
    "kz": "Алақай! Барлығы дайын!",
    "ua": "Ура! Все готово!",
    "pl": "Hurra! Wszystko gotowe!",
    "ge": "ურაა! ყველაფერი მზადაა!",
    "az": "Yaşasın! Hər şey hazırdır!",
    "": ""
  },
  "tiw__signingWithoutSms__subtitle": {
    "key": "tiw__signingWithoutSms__subtitle",
    "ru": "Договор успешно оформлен. Вам предоставят его на подписание, когда вы будете получать товар в магазине",
    "ro": "Contractul a fost procesat cu succes. Vi se va prezenta pentru semnare când veți primi marfa în magazin",
    "en": "The contract has been successfully completed. You will be given it to sign when you receive the device in the store.",
    "kz": "Шарт сәтті рәсімделді. Сізге оны дүкеннен тауар алған кезде қол қою үшін ұсынады.",
    "ua": "Договір успішно оформлено. Вам нададуть його на підписання, коли ви будете отримувати товар у магазині",
    "pl": "Umowa została pomyślnie zawarta. Otrzymasz ją do podpisu po odbiorze towaru w sklepie.",
    "ge": "ხელშეკრულება წარმატებით გაფორმდა. ხელმოწერის საშუალება გექნებათ მაღაზიაში, ახალი მოწყობილობის მიღებისას.",
    "az": "Müqavilə uğurla rəsmiləşdirilib. Məhsulu mağazadan götürərkən imzalamanız üçün təqdim olunacaq.",
    "": ""
  },
  "tiw__signingWithoutSms__downloadContract": {
    "key": "tiw__signingWithoutSms__downloadContract",
    "ru": "Скачать договор",
    "ro": "Descărcare contratului",
    "en": "Download the contract",
    "kz": "Шартты жүктеу",
    "ua": "Скачати договір",
    "pl": "Pobierz umowę",
    "ge": "ხელშეკრულების ჩამოტვირთვა",
    "az": "Müqaviləni yükləyin",
    "": ""
  },
  "tiw__signingWithoutSms__downloadContract__title": {
    "key": "tiw__signingWithoutSms__downloadContract__title",
    "ru": "Хотите ознакомиться с договором заранее?",
    "ro": "Doriți să examinați contractul în prealabil?",
    "en": "Would you like to review the contract in advance?",
    "kz": "Шартпен алдын ала танысқыңыз келе ме?",
    "ua": "Бажаєте ознайомитись з договором заздалегідь?",
    "pl": "Czy chcesz zapoznać się z umową wcześniej?",
    "ge": "გსურთ წინასწარ გადახედოთ ხელშეკრულებას?",
    "az": "Müqaviləni əvvəlcədən nəzərdən keçirmək istərdinizmi?",
    "": ""
  },
  "tiw__chooseSigningType__title": {
    "key": "tiw__chooseSigningType__title",
    "ru": "Осталось только подписать договор",
    "ro": "A rămas numai să semnați contractul",
    "en": "All that remains is to sign the contract",
    "kz": "Тек шартқа қол қою ғана қалды",
    "ua": "Залишилось лише підписати договір",
    "pl": "Pozostaje tylko podpisać umowę",
    "ge": "დარჩა მხოლოდ ხელმოწერა",
    "az": "Yalnız müqaviləni imzalamaq qalır",
    "": ""
  },
  "tiw__chooseSigningType__text": {
    "key": "tiw__chooseSigningType__text",
    "ru": "Выберите способ подписания",
    "ro": "Alegeți metoda de semnare",
    "en": "Select a signing method",
    "kz": "Қол қою әдісін таңдаңыз",
    "ua": "Виберіть спосіб підписання",
    "pl": "Wybierz metodę podpisywania",
    "ge": "აირჩიეთ ხელმოწერის მეთოდი",
    "az": "İmzalama üsulunu seçin",
    "": ""
  },
  "tiw__chooseSigningType__signingType__trustmeKz__title": {
    "key": "tiw__chooseSigningType__signingType__trustmeKz__title",
    "ru": "Подписать договор по SMS",
    "ro": "Semnează contractul prin SMS",
    "en": "Sign the contract via SMS",
    "kz": "SMS арқылы шартқа қол қою",
    "ua": "Підписати договір по SMS",
    "pl": "Podpisz umowę za pomocą SMS-a",
    "ge": "SMS ხელმოწერა",
    "az": "Müqaviləni SMS vasitəsilə imzalayın",
    "": ""
  },
  "tiw__chooseSigningType__signingType__trustmeKz__description": {
    "key": "tiw__chooseSigningType__signingType__trustmeKz__description",
    "ru": "Подпишите договор прямо сейчас, получив его на телефон и введя код подтвердждения. Это займёт 1-2 минуты и сэкономит время при получении товара",
    "ro": "Semnează contractul acum, primindu-l pe telefon și introducând codul de confirmare. Va dura 1-2 minute și va economisi timp la primirea mărfii",
    "en": "Sign the contract right now by receiving it on your phone and entering the confirmation code. This will take 1-2 minutes and will save time when receiving device",
    "kz": "Шартты телефон арқылы алып, растау кодын енгізіп, тура қазір шартқа қол қойыңыз. Бұл 1-2 минут уақытты алып, тауар алған кезде уақытты үнемдейді.",
    "ua": "Підпишіть договір прямо зараз, отримавши його на телефон та ввівши код підтвердження. Це займе 1-2 хвилини та заощадить час при отриманні товару",
    "pl": "Podpisz umowę już teraz, po otrzymaniu jej na telefonie i wpisaniu kodu potwierdzającego. Zajmie to 1-2 minuty i pozwoli zaoszczędzić czas przy odbiorze towaru.",
    "ge": "მოაწერეთ ხელშეკრულებას ხელი ახლავე მისი თქვენი მობილურში მიღებით და დამადასტურებელი კოდის შეყვანით. ამ პროცესს 1-2 წუთი დასჭირდება და, ამავდროულად, ახალი მოწყობილობის მიღებისას დროს დაზოგავთ",
    "az": "Telefonunuza qəbul edərək və təsdiq kodunu daxil etməklə müqaviləni elə indi imzalayın. 1-2 dəqiqə çəkəcək və malları qəbul edərkən vaxta qənaət edəcək.",
    "": ""
  },
  "tiw__chooseSigningType__signingType__withoutSms__title": {
    "key": "tiw__chooseSigningType__signingType__withoutSms__title",
    "ru": "Подписать договор при получении",
    "ro": "Semnează contractul la primire",
    "en": "Sign the contract upon receipt",
    "kz": "Шартты алған кезде қол қою",
    "ua": "Підписати договір при отриманні",
    "pl": "Podpisz umowę po jej otrzymaniu",
    "ge": "ხელი მოაწერეთ ხელშეკრულებას მიღებისთანავე",
    "az": "Müqaviləni aldıqdan sonra imzalayın",
    "": ""
  },
  "tiw__chooseSigningType__signingType__withoutSms__description": {
    "key": "tiw__chooseSigningType__signingType__withoutSms__description",
    "ru": "Подпишите договор во время получения товара. Это ускорит оформление заказа сейчас",
    "ro": "Semnează contractul la primirea mărfii. Acest lucru va accelera procesarea comenzii acum.",
    "en": "Sign the contract when receiving device. This will speed up your order now.",
    "kz": "Шартқа тауар алған кезде қол қойыңыз. Бұл тапсырысты қазір рәсімдеуді жеделдетеді",
    "ua": "Підпишіть договір під час отримання товару. Це прискорить оформлення замовлення зараз",
    "pl": "Podpisz umowę po otrzymaniu towaru. To przyspieszy realizację zamówienia.",
    "ge": "მოაწერე ხელი მოწყობილობის მიღებისას. ეს დააჩქარებს თქვენს შეკვეთას",
    "az": "Cihazını aldıqdan sonra müqaviləni imzalayın. Bu, indi sifarişinizi sürətləndirəcək.",
    "": ""
  },
  "tiw__howYouRateDevice__pickup_only_info": {
    "key": "tiw__howYouRateDevice__pickup_only_info",
    "ru": "Пожалуйста, учтите, что оцениваемое устройство нужно будет принести на точку выдачи заказа. Доставка заказа курьером будет недоступна.",
    "ro": "Vă rugăm să rețineți că dispozitivul evaluat va trebui adus la punctul de ridicare a comenzii. Livrarea comenzii prin curier nu va fi disponibilă.",
    "en": "Please note that the evaluated device has to be brought to the pickup point. Courier delivery will not be available.",
    "kz": "Бағаланатын құрылғыны тапсырысты алу орнына алып келу қажет екенін ескеріңіз. Тапсырысты курьер арқылы жеткізу қолжетімсіз болады.",
    "ua": "Будь ласка, врахуйте, що пристрій, який оцінюється, потрібно буде принести на точку видачі замовлення. Доставка замовлення кур'єром буде недоступною.",
    "pl": "Proszę pamiętać, że urządzenie podlegające ocenie będzie musiało zostać dostarczone do punktu odbioru zamówienia. Dostawa zamówienia kurierem nie będzie dostępna.",
    "ge": "გთხოვთ გაითვალისწინოთ, რომ შესაფასებელი მოწყობილობა უნდა მიიტანოთ აღების პუნქტში. შეკვეთის კურიერით მიწოდება შეუძლებელი იქნება.",
    "az": "Zəhmət olmasa, nəzərə alın ki, qiymətləndiriləcək cihazı sifarişin verildiyi nöqtəyə gətirmək lazım olacaq. Sifarişin kuryer ilə çatdırılması mümkün olmayacaq.\n",
    "": ""
  },
  "tiw__downloadPhotos__qrInfo_v2": {
    "key": "tiw__downloadPhotos__qrInfo_v2",
    "ru": "Используйте фотографии в формате <strong>JPG, HEIC, DNG</strong> или <strong>PNG</strong> с разрешением <strong>72 PPI</strong>.",
    "ro": "Folosiți fotografii în formatul <strong>JJPG, HEIC, DNG</strong> sau <strong>PNG</strong> cu o rezoluție de <strong>72 PPI</strong>.",
    "en": "Use photos in the format of <strong>JPG, HEIC, DNG</strong> or <strong>PNG</strong> with a resolution of <strong>72 PPI</strong>.",
    "kz": "<strong>72 PPI</strong> ажыратымдылығы бар <strong>JPG, HEIC, DNG</strong> немесе <strong>PNG</strong> фотосуреттерін пайдаланыңыз.",
    "ua": "Використовуйте фотографії у форматі <strong>JPG, HEIC, DNG</strong> або <strong>PNG</strong> з роздільною здатністю <strong>72 PPI</strong>.",
    "pl": "Użyj zdjęć w formacie <strong>JPG, HEIC, DNG</strong> lub <strong>PNG</strong> o rozdzielczości <strong>72 PPI</strong>.",
    "ge": "გამოიყენეთ შემდეგი ფორმატები: <strong>JPG, HEIC, DNG</strong> or <strong>PNG</strong> რეზოლუციით: <strong>72 PPI</strong>.",
    "az": "<strong>72 PPI</strong> təsvir ölçüsü ilə <strong>JPG, HEIC, DNG</strong> və ya <strong>PNG</strong> formatında fotolardan istifadə edin.",
    "": ""
  },
  "tiw__howYouRateDevice__discount__right__now": {
    "key": "tiw__howYouRateDevice__discount__right__now",
    "ru": "Как получить скидку прямо сейчас?",
    "ro": "Cum poți obține reducere chiar acum?",
    "en": "How to get a discount right now?",
    "kz": "Жеңілдікті дәл қазір қалай алуға болады?",
    "ua": "Як отримати знижку просто зараз?",
    "pl": "Jak uzyskać zniżkę już teraz?",
    "ge": "როგორ მივიღო ფასდაკლება ახლავე?",
    "az": "İndicə necə endirim əldə etmək olar?",
    "": ""
  },
  "tiw__howYouRateDevice__discount__right__now__snap__title": {
    "key": "tiw__howYouRateDevice__discount__right__now__snap__title",
    "ru": "Сфотографируйте устройство, которое вы продаете.",
    "ro": "Fă o poză a dispozitivului pe care îl vinzi",
    "en": "Snap a pic of the device you're selling",
    "kz": "Сатып жатқан құрылғыны суретке түсіріңіз",
    "ua": "Будь ласка, надішліть фотографію пристрою, який ви продаєте.",
    "pl": "Zrób zdjęcie urządzenia, które sprzedajesz",
    "ge": "გადაუღეთ ფოტო იმ მოწყობილობას, რასაც ყიდით",
    "az": "Zəhmət olmasa, satdığınız cihazın şəklini göndərin.",
    "": ""
  },
  "tiw__howYouRateDevice__discount__right__now__snap__text": {
    "key": "tiw__howYouRateDevice__discount__right__now__snap__text",
    "ru": "Для этого вам понадобится еще один гаджет с камерой.",
    "ro": "Veți avea nevoie de un alt gadget cu cameră pentru asta",
    "en": "You'll need another gadget with a camera for this.",
    "kz": "Ол үшін сізге тағы да камерасы бар гаджет қажет болады",
    "ua": "Для цього вам знадобиться інший пристрій з камерою.",
    "pl": "Do tego celu potrzebny będzie Ci dodatkowy gadżet z kamerą.",
    "ge": "ამისათვის დაგჭირდებათ სხვა გაჯეტი, რომელსაც აქვს კამერა",
    "az": "Bunun üçün sizə kameralı başqa bir cihaz lazım olacaq.",
    "": ""
  },
  "tiw__howYouRateDevice__discount__right__now__online__price__title": {
    "key": "tiw__howYouRateDevice__discount__right__now__online__price__title",
    "ru": "Получите онлайн-оценку на ваше устройство",
    "ro": "Obține online prețul pentru dispozitivul tău",
    "en": "Get an online price quote for your device",
    "kz": "Құрылғыңыздың бағасы бойынша онлайн ұсыныс алыңыз",
    "ua": "Отримайте онлайн-оцінку вартості вашого пристрою.",
    "pl": "Uzyskaj wycenę swojego urządzenia online",
    "ge": "მიიღეთ თქვენი მოწყობილობის ფასის ონლაინ შეთავაზება",
    "az": "Cihazınızın dəyərini onlayn qiymətləndirin.",
    "": ""
  },
  "tiw__howYouRateDevice__discount__right__now__online__price__text": {
    "key": "tiw__howYouRateDevice__discount__right__now__online__price__text",
    "ru": "Это займет всего около 5 минут.",
    "ro": "O să dureze aproximativ 5 minute",
    "en": "It'll only take about 5 minutes.",
    "kz": "Ол шамамен 5 минуттай уақыт алады",
    "ua": "Це займе близько 5 хвилин.",
    "pl": "Zajmie to tylko około 5 minut.",
    "ge": "ამას დაახლოებით მხოლოდ 5 წუთი დასჭირდება",
    "az": "Bu, təxminən 5 dəqiqə vaxt aparacaq.",
    "": ""
  },
  "tiw__howYouRateDevice__discount__right__now__dont__miss__title": {
    "key": "tiw__howYouRateDevice__discount__right__now__dont__miss__title",
    "ru": "Не упустите скидку!",
    "ro": "Nu rata reducerea!",
    "en": "Don't miss out on the discount!",
    "kz": "Жеңілдікті жіберіп алмаңыз",
    "ua": "Не пропустіть знижку!",
    "pl": "Nie przegap zniżki!",
    "ge": "არ გამოტოვოთ ფასდაკლება!",
    "az": "Endirimi qaçırmayın!",
    "": ""
  },
  "tiw__howYouRateDevice__discount__right__now__dont__miss__title_takealot": {
    "key": "tiw__howYouRateDevice__discount__right__now__dont__miss__title_takealot",
    "ru": "",
    "ro": "",
    "en": "Don't miss out on the Voucher!",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__howYouRateDevice__discount__right__now__dont__miss__text": {
    "key": "tiw__howYouRateDevice__discount__right__now__dont__miss__text",
    "ru": "Получите новое устройство со скидкой при сдаче старого.",
    "ro": "Cumpără unul nou cu reducere atunci când schimbi dispozitivul vechi.",
    "en": "Grab a new one at a discount when you trade in your old device.",
    "kz": "Өзіңіздің ескі құрылғыңызды жаңа құрылғыға жеңілдікпен айырбастаңыз",
    "ua": "Придбайте новий пристрій зі знижкою, обмінявши свій старий.",
    "pl": "Oddaj stare urządzenie i otrzymaj nowe w niższej cenie.",
    "ge": "წაიღეთ ახალი მოწყობილობა ფასდაკლებით ძველის ჩაბარებისას.",
    "az": "Köhnə cihazınızı təhvil verərək, yeni cihazı endirimlə alın.",
    "": ""
  },
  "tiw__howYouRateDevice__discount__right__now__dont__miss__text_takealot": {
    "key": "tiw__howYouRateDevice__discount__right__now__dont__miss__text_takealot",
    "ru": "",
    "ro": "",
    "en": "Get a Takealot Voucher for the value of your old device",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__howYouRateDevice__discount__right__button__get__title": {
    "key": "tiw__howYouRateDevice__discount__right__button__get__title",
    "ru": "Получите скидку позже",
    "ro": "Obține o reducere mai târziu",
    "en": "Get a discount later",
    "kz": "Жеңілдікті кейінірек алыңыз",
    "ua": "Отримати знижку пізніше.",
    "pl": "Uzyskaj zniżkę później",
    "ge": "მიიღეთ ფასდაკლება მოგვიანებით",
    "az": "Endirimi daha sonra əldə etmək.",
    "": ""
  },
  "tiw__howYouRateDevice__discount__right__button__get__text": {
    "key": "tiw__howYouRateDevice__discount__right__button__get__text",
    "ru": "Получите скидку офлайн после оценки эксперта в магазине или при получении курьером.",
    "ro": "Primește o reducere offline după o evaluare efectuată de un expert, fie direct în magazin, fie la colectarea de către curier.",
    "en": "Receive a discount offline after an expert evaluation, either in-store or upon courier collection.",
    "kz": "Жеңілдікті сарапшылардың бағалауынан кейін дүкенде немесе курьер\n  арқылы жеткізумен алыңыз",
    "ua": "Отримайте знижку офлайн після експертної оцінки — у магазині або під час забору кур’єром.",
    "pl": "Otrzymasz zniżkę offline po konsultacji z ekspertem, w sklepie lub przy odbiorze przesyłki kurierskiej.",
    "ge": "მიიღეთ ფასდაკლება ადგილზე, ექსპერტის მიერ შეფასებისას ან მაღაზიაში, ან კურიერთან",
    "az": "Ekspert qiymətləndirməsindən sonra endirimi oflayn şəkildə əldə edin — mağazada və ya kuryer tərəfindən götürülmə zamanı.",
    "": ""
  },
  "tiw__successfulEvaluation__contact_title": {
    "key": "tiw__successfulEvaluation__contact_title",
    "ru": "Контактные данные",
    "ro": "Date de contact",
    "en": "Contact details",
    "kz": "Байланыс деректері",
    "ua": "Контактні дані",
    "pl": "Dane kontaktowe",
    "ge": "საკონტაქტო დეტალები",
    "az": "Əlaqə məlumatları",
    "": ""
  },
  "tiw__reasonsCancellation__title": {
    "key": "tiw__reasonsCancellation__title",
    "ru": "Вы уверены, что хотите отменить?",
    "ro": "Sunteți sigur că doriți să anulați?",
    "en": "Do you really want to cancel?",
    "kz": "Шынымен болдырмауды қалайсыз ба?",
    "ua": "Ви впевнені, що хочете скасувати?",
    "pl": "Czy na pewno chcesz anulować?",
    "ge": "ნამდვილად გსურთ გაუქმება?",
    "az": "Ləğv etmək istədiyinizə əminsiniz?",
    "": ""
  },
  "tiw__reasonsCancellation__description": {
    "key": "tiw__reasonsCancellation__description",
    "ru": "Пожалуйста, укажите причину отмены оценки устройства.",
    "ro": "Vă rugăm să oferiți un motiv pentru anularea evaluării dispozitivului.",
    "en": "Please provide a reason for canceling the device evaluation",
    "kz": "Құрылғыны бағалауды болдырмау себебін көрсетіңіз",
    "ua": "Будь ласка, вкажіть причину скасування оцінки пристрою.",
    "pl": "Proszę podać powód anulowania oceny urządzenia",
    "ge": "გთხოვთ, წარადგინეთ მოწყობილობის შეფასების გაუქმების მიზეზი",
    "az": "Zəhmət olmasa, cihazın qiymətləndirilməsini niyə ləğv etdiyinizi qeyd edin.",
    "": ""
  },
  "tiw__reasonsCancellation__button__cancel": {
    "key": "tiw__reasonsCancellation__button__cancel",
    "ru": "\nОтменить оценку",
    "ro": "Anulare evaluării",
    "en": "Cancel evaluation",
    "kz": "Бағалауды болдырмау",
    "ua": "Скасувати оцінку",
    "pl": "Anuluj ocenę",
    "ge": "შეფასების გაუქმება",
    "az": "Qiymətləndirməni ləğv et",
    "": ""
  },
  "tiw__reasonsCancellation__button__return": {
    "key": "tiw__reasonsCancellation__button__return",
    "ru": "Вернуться к оценке",
    "ro": "Reveniți la evaluare",
    "en": "Return to evaluation",
    "kz": "Бағалауға оралу",
    "ua": "Повернутися до оцінки",
    "pl": "Powrót do oceny",
    "ge": "შეფასებაზე დაბრუნება",
    "az": "Qiymətləndirməyə qayıt",
    "": ""
  },
  "tiw__addToCartWithoutSms": {
    "key": "tiw__addToCartWithoutSms",
    "ru": "",
    "ro": "",
    "en": "The agreement will be signed in the store upon receipt of the goods.",
    "kz": "Шартқа тауарды алғаннан кейін дүкенде қол қойылады.",
    "ua": "Договір буде підписано в магазині після отримання товару.",
    "pl": "",
    "ge": "ხელშეკრულების ხელის მოწერა ხდება მაღაზიაში საქონლის მიღებისთანავე.",
    "az": "SMS göndərmədən səbətə əlavə et",
    "": ""
  },
  "tiw__crunch__contactUsAfter": {
    "key": "tiw__crunch__contactUsAfter",
    "ru": "c нами",
    "ro": "cu noi",
    "en": "us",
    "kz": "біз",
    "ua": "з нами",
    "pl": "z nami",
    "ge": "ჩვენთან ერთად",
    "az": "Bizimlə",
    "": ""
  },
  "tiw__validation__required": {
    "key": "tiw__validation__required",
    "ru": "Поле обязательно к заполнению",
    "ro": "Câmpul este obligatoriu",
    "en": "The field must be filled in",
    "kz": "Өрісті міндетті түрде толтыру керек",
    "ua": "Поле обов'язкове для заповнення",
    "pl": "Pole musi być wypełnione",
    "ge": "ამ ველის შევსება აუცილებელია",
    "az": "Xana doldurulmalıdır / Mütləq doldurulmalı sahə",
    "": ""
  },
  "tiw__validation__id_number_required": {
    "key": "tiw__validation__id_number_required",
    "ru": "",
    "ro": "",
    "en": "The ID Number field must be filled in",
    "kz": "Осы өрісте міндетті түрде жеке куәліктің нөмірін көрсетіңіз",
    "ua": "Поле «Ідентифікаційний номер» має бути заповнене",
    "pl": "",
    "ge": "ID ნომრის შევსება აუცილებელია",
    "az": "Şəxsiyyət vəsiqəsi nömrəsi sahəsi doldurulmalıdır.",
    "": ""
  },
  "tiw__validation__id_number_range": {
    "key": "tiw__validation__id_number_range",
    "ru": "",
    "ro": "",
    "en": "The ID Number field should consist only of numbers and 13 characters",
    "kz": "Жеке куәліктің нөміріне арналған өрісте сандар ғана болуы және 13 таңбадан тұруы тиіс",
    "ua": "Поле «Ідентифікаційний номер» повинно містити лише цифри та 10 символів.",
    "pl": "",
    "ge": "ID ნომერი უნდა შეიცავდეს მხოლოდ ნომრებს და არ აღემატებოდეს 13 სიმბოლოს",
    "az": "Şəxsiyyət vəsiqəsi nömrəsi sahəsi yalnız rəqəmlərdən ibarət olmalı və 13 simvol uzunluğunda olmalıdır.",
    "": ""
  },
  "tiw__validation__date_required": {
    "key": "tiw__validation__date_required",
    "ru": "Поле Дата обязательно к заполнению",
    "ro": "Câmpul Data este obligatoriu",
    "en": "The Date field must be filled in",
    "kz": "Date өрісі міндетті түрде толтырылады",
    "ua": "Поле Дата обов'язкове до заповнення",
    "pl": "Pole Date musi być wypełnione",
    "ge": "თარიღის შევსება აუცილებელია",
    "az": "Telefon sahəsi tələb olunur.",
    "": ""
  },
  "tiw__validation__date_incorrect": {
    "key": "tiw__validation__date_incorrect",
    "ru": "Введите корректную дату",
    "ro": "Introduceți data corectă",
    "en": "Enter the correct Date address",
    "kz": "Дұрыс Date енгізіңіз",
    "ua": "Введіть правильну дату",
    "pl": "Wprowadź poprawny adres date",
    "ge": "შეიყვანეთ სწორი თარიღი",
    "az": "Düzgün ünvanı daxil edin",
    "": ""
  },
  "tiw__chooseDevice__terms__ua_breezy": {
    "key": "tiw__chooseDevice__terms__ua_breezy",
    "ru": "Больше информации вы найдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\">Условиях использования Breezy Trade-In</a>.",
    "ro": "Mai multă informație găsiți în <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\">Condiții de utilizare Breezy Trade-In</a>.",
    "en": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\">Breezy Trade-In Terms of Uses </a>.",
    "kz": "<a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\">Қосымша ақпаратты Breezy Trade-In</a> пайдалану шарттарынан таба аласыз.'",
    "ua": "Більше інформації ви знайдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\">Умовах використання Breezy Trade-In</a>.",
    "pl": "Więcej informacji można znaleźć w <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\">Regulamin Odkupu Breezy</a>.",
    "ge": "",
    "az": "Ətraflı məlumat üçün <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\">Breezy Trade-In İstifadə Şərtlərinə</a> baxın.",
    "": ""
  },
  "tiw__chooseDevice__terms__ua_foxtrot": {
    "key": "tiw__chooseDevice__terms__ua_foxtrot",
    "ru": "Больше информации вы найдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/trade-in-legal_Foxtrot.pdf\">Условиях использования Breezy Trade-In</a>.",
    "ro": "Mai multă informație găsiți în <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/trade-in-legal_Foxtrot.pdf\">Condiții de utilizare Breezy Trade-In</a>.",
    "en": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/trade-in-legal_Foxtrot.pdf\">Breezy Trade-In Terms of Uses </a>.",
    "kz": "<a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/trade-in-legal_Foxtrot.pdf\">Қосымша ақпаратты Breezy Trade-In</a> пайдалану шарттарынан таба аласыз.",
    "ua": "Більше інформації ви знайдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/trade-in-legal_Foxtrot.pdf\">Умовах використання Breezy Trade-In</a>.",
    "pl": "Więcej informacji można znaleźć w <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/trade-in-legal_Foxtrot.pdf\">Regulamin Odkupu Breezy</a>.",
    "ge": "",
    "az": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/trade-in-legal_Foxtrot.pdf\">Breezy Trade-In Terms of Uses </a>.",
    "": ""
  },
  "tiw__chooseDevice__terms__za_avo_africa": {
    "key": "tiw__chooseDevice__terms__za_avo_africa",
    "ru": "Больше информации вы найдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf\">Условиях использования Breezy Trade-In</a>.",
    "ro": "Mai multă informație găsiți în <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf\">Condiții de utilizare Breezy Trade-In</a>.",
    "en": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf\">Breezy Trade-In Terms of Uses </a>.",
    "kz": "<a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf\">Қосымша ақпаратты Breezy Trade-In</a> пайдалану шарттарынан таба аласыз.",
    "ua": "Більше інформації ви знайдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf\">Умовах використання Breezy Trade-In</a>.",
    "pl": "Więcej informacji można znaleźć w <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf\">Regulamin Odkupu Breezy</a>.",
    "ge": "",
    "az": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf\">Breezy Trade-In Terms of Uses </a>.",
    "": ""
  },
  "tiw__chooseDevice__terms__za_takealot": {
    "key": "tiw__chooseDevice__terms__za_takealot",
    "ru": "",
    "ro": "",
    "en": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/TAL_client_trade_in_agreement_General_T_and_C.pdf\">Breezy Trade-In Terms of Uses </a>.",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__chooseDevice__terms__za_dg_co": {
    "key": "tiw__chooseDevice__terms__za_dg_co",
    "ru": "Больше информации вы найдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf\">Условиях использования Breezy Trade-In</a>.",
    "ro": "Mai multă informație găsiți în <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf\">Condiții de utilizare Breezy Trade-In</a>.",
    "en": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf\">Breezy Trade-In Terms of Uses </a>.",
    "kz": "<a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf\">Қосымша ақпаратты Breezy Trade-In</a> пайдалану шарттарынан таба аласыз.",
    "ua": "Більше інформації ви знайдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf\">Умовах використання Breezy Trade-In</a>.",
    "pl": "Więcej informacji można znaleźć w <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf\">Regulamin Odkupu Breezy</a>.",
    "ge": "",
    "az": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf\">Breezy Trade-In Terms of Uses </a>.",
    "": ""
  },
  "tiw__chooseDevice__terms__md": {
    "key": "tiw__chooseDevice__terms__md",
    "ru": "Больше информации вы найдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Trade-In_Terms_and_Conditions_RU.pdf\">Условиях использования Breezy Trade-In</a>.",
    "ro": "Mai multă informație găsiți în <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Trade-In_Terms_and_Conditions_RO.pdf\">Condiții de utilizare Breezy Trade-In</a>.",
    "en": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Trade-In_Terms_and_Conditions_RO.pdf\">Breezy Trade-In Terms of Uses </a>.",
    "kz": "<a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Trade-In_Terms_and_Conditions_RO.pdf\">Қосымша ақпаратты Breezy Trade-In</a> пайдалану шарттарынан таба аласыз.",
    "ua": "Більше інформації ви знайдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Trade-In_Terms_and_Conditions_RO.pdf\">Умовах використання Breezy Trade-In</a>.",
    "pl": "Więcej informacji można znaleźć w <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Trade-In_Terms_and_Conditions_RO.pdf\">Regulamin Odkupu Breezy</a>.",
    "ge": "",
    "az": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Trade-In_Terms_and_Conditions_RO.pdf\">Breezy Trade-In Terms of Uses </a>.",
    "": ""
  },
  "tiw__chooseDevice__terms__ge": {
    "key": "tiw__chooseDevice__terms__ge",
    "ru": "Больше информации вы найдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Customer-Facing-General-T-and-Cs-EN.pdf\">Условиях использования Breezy Trade-In</a>.",
    "ro": "Mai multă informație găsiți în <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Customer-Facing-General-T-and-Cs-EN.pdf\">Condiții de utilizare Breezy Trade-In</a>.",
    "en": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Customer-Facing-General-T-and-Cs-EN.pdf\">Breezy Trade-In Terms of Uses </a>.",
    "kz": "<a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Customer-Facing-General-T-and-Cs-EN.pdf\">Қосымша ақпаратты Breezy Trade-In</a> пайдалану шарттарынан таба аласыз.",
    "ua": "Більше інформації ви знайдете в <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Customer-Facing-General-T-and-Cs-EN.pdf\">Умовах використання Breezy Trade-In</a>.",
    "pl": "Więcej informacji można znaleźć w <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Customer-Facing-General-T-and-Cs-EN.pdf\">Regulamin Odkupu Breezy</a>.",
    "ge": "დამატებით ინფორმაციას იხილავთ <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Customer-Facing-General-T-and-Cs-GE.pdf\">Breezy Trade-In Terms of Uses-ში </a>.",
    "az": "You will find more information in the <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/Customer-Facing-General-T-and-Cs-EN.pdf\">Breezy Trade-In Terms of Uses </a>.",
  },
  "tiw__downloadPhotos__networkError": {
    "key": "tiw__downloadPhotos__networkError",
    "ru": "К сожалению, возникла проблема при загрузке фотографий. Пожалуйста, убедитесь, что используете стабильное Интернет-соединение и попробуйте загрузить их ещё раз.",
    "ro": "Din păcate, a apărut o problemă la încărcarea fotografiilor. Asigurați-vă că aveți o conexiune stabilă la internet și încearcați să le încărcați din nou.",
    "en": "Unfortunately an issue has occurred while uploading the photos. Please make sure that you have a stable Internet connection and try again.",
    "kz": "Өкінішке орай, суреттерді жүктеуде мәселе туындады. Тұрақты интернет байланысын пайдаланып жатқаныңызды тексеріп, қайтадан жүктеп көріңіз.",
    "ua": "На жаль, виникла проблема при завантаженні фотографій. Будь ласка, переконайтесь, що використовуєте стабільне інтернет-з'єднання, і спробуйте завантажити їх знову.",
    "pl": "Niestety wystąpił problem z przesyłaniem zdjęć. Proszę sprawdzić swoje połączenie internetowe i spróbować ponownie.",
    "ge": "სამწუხაროდ დაფიქსირდა ხარვეზი ფოტოების ატვირთვის დროს. გთხოვთ დარწმუნდით, რომ გაქვთ სტაბილური ინტერნეტ კავშირი და ხელახლა სცადოთ.",
    "az": "Unfortunately an issue has occurred while uploading the photos. Please make sure that you have a stable Internet connection and try again.",
    "": ""
  },
  "tiw__successfulEvaluation__fio_location-za": {
    "key": "tiw__successfulEvaluation__fio_location-za",
    "ru": "Полное имя",
    "ro": "Numele plin",
    "en": "Full name",
    "kz": "Т.А.Ә.",
    "ua": "ПІБ",
    "pl": "Imię i nazwisko",
    "ge": "",
    "az": "Tam ad",
    "": ""
  },
  "tiw__successfulEvaluation__id_number": {
    "key": "tiw__successfulEvaluation__id_number",
    "ru": "Номер ID",
    "ro": "IDNP",
    "en": "ID Number",
    "kz": "Жеке куәліктің нөмірі",
    "ua": "Ідентифікаційний номер",
    "pl": "Numer dokumentu tożsamości",
    "ge": "ID ნომერი",
    "az": "Şəxsiyyət vəsiqəsinin nömrəsi",
    "": ""
  },
  "tiw__successfulEvaluation__passportSeriesNumber": {
    "key": "tiw__successfulEvaluation__passportSeriesNumber",
    "ru": "Серия и номер паспорта",
    "ro": "Seria buletinului de identitate",
    "en": "Passport series and number",
    "kz": "Төлқұжаттың сериясы мен нөмірі",
    "ua": "Серія та номер паспорта",
    "pl": "Seria i numer paszportu",
    "ge": "პასპორტის სერიული და ნომერი",
    "az": "Pasportun seriyası və nömrəsi",
    "": ""
  },
  "tiw__successfulEvaluation__passportIssueDate": {
    "key": "tiw__successfulEvaluation__passportIssueDate",
    "ru": "Дата выдачи",
    "ro": "Data de eliberare",
    "en": "Passport issue date",
    "kz": "Төлқұжаттың берілген күні",
    "ua": "Дата видачі",
    "pl": "Data wydania",
    "ge": "პასპორტის გაცემის თარიღი",
    "az": "Pasportun verilmə tarixi",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_personal__ua_breezy": {
    "key": "tiw__successfulEvaluation__checkbox_personal__ua_breezy",
    "ru": "Я соглашаюсь на обработку моих <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\"> персональных данных </a> и <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\"> условия Trade-In </a>",
    "ro": "Sunt de acord cu prelucrarea a <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\"> datelor personale </a> и <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\"> condiții de Trade-In </a>",
    "en": "I agree to the processing of my <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\"> personal data </a> and <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\"> Trade-In terms </a>",
    "kz": "Мен <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\"> жеке деректерімді </a> және <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\"> cауда шарттары</a>",
    "ua": "Я погоджуюсь на обробку моїх <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\"> персональних даних </a> та <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\">умови Trade-In</a>",
    "pl": "Wyrażam zgodę na przetwarzanie moich <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\"> danych osobowych </a> oraz <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\"> warunków Trade-In </a>",
    "ge": "",
    "az": "Mən <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\"> şəxsi məlumatlarımın </a> və <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"-band\" target=\"blank\" href=\"-band\"https://pd.kz/\"-in emalı ilə razıyam. </a>",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_personal__ua_comfy": {
    "key": "tiw__successfulEvaluation__checkbox_personal__ua_comfy",
    "ru": "Я соглашаюсь на обработку моих персональных данных согласно <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://zakon.rada.gov.ua/laws/show/2297-17#Text\">Закону Украины \"Про защиту персональных данных\"</a> и <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\">условия Trade-In</a>",
    "ro": "",
    "en": "",
    "kz": "",
    "ua": "Я погоджуюсь на обробку моїх персональних даних згідно <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://zakon.rada.gov.ua/laws/show/2297-17#Text\">Закону України \"Про захист персональних даних\"</a> та <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\">умови Trade-In</a>",
    "pl": "Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z <a class=\"tiw__link tiw__link_theme-light\" target=\"_blank\" href=\"https://zakon.rada.gov.ua/laws/show/2297-17#Text\">ukraińską ustawą „O ochronie danych osobowych”</a> oraz <a class=\"tiw__link tiw__link_theme-light\" target=\"_blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\">warunków Trade-In</a>",
    "ge": "",
    "az": "Mən öz şəxsi məlumatlarımın işlənməsinə razılıq verirəm <a class=\"tiw__link tiw__link_theme-light\" target=\"_blank\" href=\"https://zakon.rada.gov.ua/laws/show/2297-17#Text\">Ukrayna “Şəxsi məlumatların qorunması haqqında” Qanununa</a> və <a class=\"tiw__link tiw__link_theme-light\" target=\"_blank\" href=\"https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf\">Breezy Trade-In şərtlərinə</a> uyğun olaraq.\r",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_personal__ua_foxtrot": {
    "key": "tiw__successfulEvaluation__checkbox_personal__ua_foxtrot",
    "ru": "Я соглашаюсь на обработку моих персональных данных согласно <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://zakon.rada.gov.ua/laws/show/2297-17#Text\">Закону Украины \"Про защиту персональных данных\"</a> и <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/trade-in-legal_Foxtrot.pdf\">условия Trade-In</a>",
    "ro": "",
    "en": "",
    "kz": "",
    "ua": "Я погоджуюсь на обробку моїх персональних даних згідно <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://zakon.rada.gov.ua/laws/show/2297-17#Text\">Закону України \"Про захист персональних даних\"</a> та <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://breezy.band/trade-in-legal_Foxtrot.pdf\">умови Trade-In</a>",
    "pl": "Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z <a class=\"tiw__link tiw__link_theme-light\" target=\"_blank\" href=\"https://zakon.rada.gov.ua/laws/show/2297-17#T",
    "ge": "",
    "az": "Mən öz şəxsi məlumatlarımın işlənməsinə razılıq verirəm <a class=\"tiw__link tiw__link_theme-light\" target=\"_blank\" href=\"https://zakon.rada.gov.ua/laws/show/2297-17#Text\">Ukr\r\n",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_personal__za_avo_africa": {
    "key": "tiw__successfulEvaluation__checkbox_personal__za_avo_africa",
    "ru": "",
    "ro": "",
    "en": "I agree to the processing of my <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://www.gov.za/documents/protection-personal-information-act\"> personal data </a> and <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf\"> Trade-In terms </a>",
    "kz": "",
    "ua": "Я погоджуюся на обробку моїх <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://www.gov.za/documents/protection-personal-information-act\"> персональних даних </a> та <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf\"> умов обміну </a>",
    "pl": "Wyrażam zgodę na przetwarzanie moich <a class=\"tiw__link tiw__link_theme-light\" target=\"_blank\" href=\"https://www.gov.za/documents/protection-personal-information-act\">danych osobowych</a> oraz <a class=\"tiw__link tiw__link_theme-light\" target=\"_blank\" href=\"https://cdn.new-brz.net/pub",
    "ge": "",
    "az": "Mən öz <a class=\"tiw__link tiw__link_theme-light\" target=\"_blank\" href=\"https://www.gov.za/documents/protection-personal-information-act\">şəxsi məlumatlarımın</a> işlənməsinə və <a class=\"tiw__link tiw__link_theme-light\" target=\"_blank\" href=\"https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf\">Trade-In şərtlərinə</a> razılıq verirəm.\r",
    "": ""
  },
  "tiw__successfulEvaluation__checkbox_personal__za_dg_co": {
    "key": "tiw__successfulEvaluation__checkbox_personal__za_dg_co",
    "ru": "",
    "ro": "",
    "en": "I agree to the processing of my <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://www.gov.za/documents/protection-personal-information-act\"> personal data </a> and <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf\"> Trade-In terms </a>",
    "kz": "",
    "ua": "Я погоджуюся на обробку моїх <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://www.gov.za/documents/protection-personal-information-act\"> персональних даних </a> та <a class=\"tiw__link tiw__link_theme-light\" target=\"blank\" href=\"https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf\"> умов обміну </a>",
    "pl": "",
    "ge": "",
    "az": "Mən öz <a class=\"tiw__link tiw__link_theme-light\" target=\"_blank\" href=\"https://www.gov.za/documents/protection-personal-information-act\">şəxsi məlumatlarımın</a> işlənməsinə və <a class=\"tiw__link tiw__link_theme-light\" target=\"_blank\" href=\"https://cdn.new-brz.net/public/static/digital_generation_general_t_a\r\n",
    "": ""
  },
  "tiw__successfulEvaluation__continue": {
    "key": "tiw__successfulEvaluation__continue",
    "ru": "Продолжить",
    "ro": "Continuare",
    "en": "Continue",
    "kz": "Жалғастыру",
    "ua": "Продовжити",
    "pl": "Kontynuuj",
    "ge": "გაგრძელება",
    "az": "Davam et",
    "": ""
  },
  "tiw__chooseSigningType__signingType__scrive__title": {
    "key": "tiw__chooseSigningType__signingType__scrive__title",
    "ru": "",
    "ro": "",
    "en": "Scrive title",
    "kz": "Scrive тақырыпаты",
    "ua": "Ввести заголовок",
    "pl": "",
    "ge": "Scrive-ის სათაური",
    "az": "Başlıq yazın",
    "": ""
  },
  "tiw__chooseSigningType__signingType__scrive__description": {
    "key": "tiw__chooseSigningType__signingType__scrive__description",
    "ru": "",
    "ro": "",
    "en": "Scrive description",
    "kz": "Scrive сипаттауы",
    "ua": "Опис скриньки",
    "pl": "",
    "ge": "Scrive-ის აღწერა",
    "az": "Təsvir yazın",
    "": ""
  },
  "tiw__ok": {
    "key": "tiw__ok",
    "ru": "Ok",
    "ro": "Ok",
    "en": "Ok",
    "kz": "Ok",
    "ua": "Ok",
    "pl": "Ok",
    "ge": "Ok",
    "az": "Ok",
    "": ""
  },
  "tiw__successfulEvaluation__send__application": {
    "key": "tiw__successfulEvaluation__send__application",
    "ru": "Отправить заявку",
    "ro": "",
    "en": "Send application",
    "kz": "",
    "ua": "",
    "pl": "Wyślij zgłoszenie",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__agreeReceiveNewsletter": {
    "key": "tiw__agreeReceiveNewsletter",
    "ru": "I agree to receive newsletter updates",
    "ro": "I agree to receive newsletter updates",
    "en": "I agree to receive newsletter updates",
    "kz": "I agree to receive newsletter updates",
    "ua": "I agree to receive newsletter updates",
    "pl": "Zgadzam się na otrzymywanie newslettera",
    "ge": "I agree to receive newsletter updates",
    "az": "I agree to receive newsletter updates",
    "": ""
  },
  "tiw__thanksYou__title": {
    "key": "tiw__thanksYou__title",
    "ru": "Спасибо!",
    "ro": "Mulțumim!",
    "en": "Thank you!",
    "kz": "Рахмет!",
    "ua": "Дякую!",
    "pl": "Dziękujemy!",
    "ge": "გმადლობთ!",
    "az": "Təşəkkür edirik!",
    "": ""
  },
  "tiw__thanksYou__text": {
    "key": "tiw__thanksYou__text",
    "ru": "Контракт подписан!",
    "ro": "Contractul a fost semnat!",
    "en": "The contract has been signed correctly!",
    "kz": "Шарт қол қойылды!",
    "ua": "Контракт підписан!",
    "pl": "Umowa została podpisana!",
    "ge": "ხელშეკრულება გაფორმდა!",
    "az": "Müqavilə düzgün imzalandı!",
    "": ""
  },
  "tiw__thanksYou__pleaseProvide": {
    "key": "tiw__thanksYou__pleaseProvide",
    "ru": "Пожалуйста, укажите адрес, с которого курьер заберет телефон.",
    "ro": "Vă rugăm să indicați adresa de unde curierul va ridica telefonul.",
    "en": "Please provide the address from which the courier will pick up the phone.",
    "kz": "Көрсетілген мекенжай бойынша курьер телефонды алып кетеді.",
    "ua": "Будь ласка, вкажіть адресу, з якої кур'єр забере телефон.",
    "pl": "Prosimy o podanie adresu, z którego kurier odbierze telefon.",
    "ge": "გთხოვთ, მიუთითოთ მისამართი, საიდანაც კურიერი წაიღებს ტელეფონს.",
    "az": "Kuryerin telefonu götürəcəyi ünvanı qeyd edin.",
    "": ""
  },
  "tiw__thanksYou_useTheSameAddress": {
    "key": "tiw__thanksYou_useTheSameAddress",
    "ru": "Использовать тот же адрес",
    "ro": "Folosiți aceeași adresă",
    "en": "Use the same address from contract signing",
    "kz": "Келісімшартқа қол қою кезіндегі мекенжайды пайдаланыңыз",
    "ua": "Використовувати ту ж адресу, що і при підписанні договору",
    "pl": "Użyj tego samego adresu, który podałeś przy podpisywaniu umowy",
    "ge": "გამოიყენეთ იგივე მისამართი, რაც ხელშეკრულების გაფორმებისას",
    "az": "Müqavilə imzalayarkən eyni ünvandan istifadə edin",
    "": ""
  },
  "tiw__thanksYou_pleaseSpecifyArrivalDate": {
    "key": "tiw__thanksYou_pleaseSpecifyArrivalDate",
    "ru": "Please specify the courier's arrival date",
    "ro": "Vă rugăm să specificați data sosirii curierului",
    "en": "Please specify the courier's arrival date",
    "kz": "Курьердің келу күнін көрсетіңіз",
    "ua": "",
    "pl": "Proszę podać datę przyjazdu kuriera",
    "ge": "მიუთითეთ კურიერის მოსვლის თარიღი",
    "az": "",
    "": ""
  },
  "tiw__thanksForOrder__text": {
    "key": "tiw__thanksForOrder__text",
    "ru": "Заявка на Trade-in успешно принята. Пожалуйста, проверьте почту — мы отправили письмо с дальнейшими шагами.",
    "ro": "Cererea de Trade-in a fost acceptată cu succes. Vă rugăm să verificați e-mailul pentru instrucțiuni suplimentare.",
    "en": "Trade-in submission successful. Please watch out for an email with the next steps.",
    "kz": "Trade-in өтінімі сәтті қабылданды. Келесі қадамдар туралы ақпарат алу үшін электрондық поштаңызды тексеріңіз.",
    "ua": "Заявка на Trade-in успішно прийнята. Будь ласка, перевірте пошту — ми надіслали лист із подальшими кроками.",
    "pl": "Zgłoszenie Trade-in zostało przyjęte. Prosimy o sprawdzenie skrzynki e-mail, wysłaliśmy instrukcje dotyczące kolejnych kroków.",
    "ge": "Trade-in განაცხადი წარმატებით მიღებულია. გთხოვთ, შეამოწმოთ ელ-ფოსტა შემდგომი ნაბიჯების შესახებ ინსტრუქციებისთვის.",
    "az": "Trade-in müraciəti uğurla qəbul edildi. Növbəti addımlarla bağlı təlimatlar üçün zəhmət olmasa e-poçtunuzu yoxlayın.",
    "": ""
  },
  "tiw__visualEvaluation__title": {
    "key": "tiw__visualEvaluation__title",
    "ru": "Визуальная оценка",
    "ro": "Визуальная оценка",
    "en": "Visual assessment",
    "kz": "Визуальная оценка",
    "ua": "Визуальная оценка",
    "pl": "Ocena wizualna",
    "ge": "Визуальная оценка",
    "az": "Визуальная оценка",
    "": ""
  },
  "tiw__chooseDevice__RAM": {
    "key": "tiw__chooseDevice__RAM",
    "ru": "Оперативная память",
    "ro": "",
    "en": "RAM",
    "kz": "Жедел жад",
    "ua": "Оперативна пам'ять",
    "pl": "Pamięć RAM",
    "ge": "",
    "az": "Operativ yaddaş",
    "": ""
  },
  "tiw__chooseDevice__Memory": {
    "key": "tiw__chooseDevice__Memory",
    "ru": "Накопитель",
    "ro": "",
    "en": "Storage",
    "kz": "Сақтау құрылғылары",
    "ua": "Накопичувач",
    "pl": "Dysk twardy",
    "ge": "",
    "az": "Yaddaş qurğusu",
    "": ""
  },
  "tiw__chooseDevice__GPU": {
    "key": "tiw__chooseDevice__GPU",
    "ru": "Видеокарта",
    "ro": "",
    "en": "Video card",
    "kz": "Бейнекарта",
    "ua": "Відеокарта",
    "pl": "Karta graficzna",
    "ge": "",
    "az": "Video kart",
    "": ""
  },
  "tiw__chooseDevice__CPU": {
    "key": "tiw__chooseDevice__CPU",
    "ru": "Процессор",
    "ro": "",
    "en": "CPU",
    "kz": "Процессор",
    "ua": "Процесор",
    "pl": "Procesor",
    "ge": "",
    "az": "Prosesor",
    "": ""
  },
  "tiw__appleDiagnostic__title": {
    "key": "tiw__appleDiagnostic__title",
    "ru": "",
    "ro": "",
    "en": "Apple Functional Diagnostics",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__appleDiagnostic__followSteps": {
    "key": "tiw__appleDiagnostic__followSteps",
    "ru": "",
    "ro": "",
    "en": "To test the device, please follow a few simple steps.",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__appleDiagnostic__toStart__mobile": {
    "key": "tiw__appleDiagnostic__toStart__mobile",
    "ru": "",
    "ro": "",
    "en": "To start the diagnostic process, click the <b>Start diagnostics</b> button or scan this QR code with your phone's camera and tap the Open button in the \"Diagnostics\" app. <br> <b>Please ensure that Safari is set as the default browser on your device.</b>",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__appleDiagnostic__toStart__desktop": {
    "key": "tiw__appleDiagnostic__toStart__desktop",
    "ru": "",
    "ro": "",
    "en": "To start the diagnostic process, scan this QR code with your phone's camera and tap the Open button inthe \"Diagnostics\" app.",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__appleDiagnostic__startDiagnostics": {
    "key": "tiw__appleDiagnostic__startDiagnostics",
    "ru": "",
    "ro": "",
    "en": "Start diagnosis",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__appleDiagnostic__acceptTerms": {
    "key": "tiw__appleDiagnostic__acceptTerms",
    "ru": "",
    "ro": "",
    "en": "Accept the terms of the agreement",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__appleDiagnostic__startAutomatically": {
    "key": "tiw__appleDiagnostic__startAutomatically",
    "ru": "",
    "ro": "",
    "en": "The diagnostic process will start automatically, and you will see a progress indicator along with the message <b>“Reseller Trade-In.”</b> The process will take about one minute and will not require any action from you.",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__appleDiagnostic__indicatorDisappeared": {
    "key": "tiw__appleDiagnostic__indicatorDisappeared",
    "ru": "",
    "ro": "",
    "en": "If the progress indicator has disappeared and the message <b>\"Waiting to Support...\"</b> has appeared, it means that the <b>test is complete.</b> Please click the <b>Continue</b> button below to proceed with the processing.",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__confirmBelowPrice__title": {
    "key": "tiw__confirmBelowPrice__title",
    "ru": "",
    "ro": "",
    "en": "Important!",
    "kz": "",
    "ua": "",
    "pl": "Ważna informacja",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__confirmBelowPrice__text": {
    "key": "tiw__confirmBelowPrice__text",
    "ru": "",
    "ro": "",
    "en": "To continue, please confirm the information below.",
    "kz": "",
    "ua": "",
    "pl": "Aby kontynuować, prosimy o potwierdzenie poniższej informacji.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__confirmBelowPrice__checkbox": {
    "key": "tiw__confirmBelowPrice__checkbox",
    "ru": "",
    "ro": "",
    "en": "I confirm that by choosing this method to complete the contract process, I have knowingly agreed to <b>a device price equal to 70% of its original valuation.</b>",
    "kz": "",
    "ua": "",
    "pl": "Potwierdzam, że wybierając ten sposób dokończenia procesu zawarcia umowy, świadomie zgodziłam/em <b>się na cenę urządzenia, która stanowi 70% jego pierwotnej wyceny.</b>",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__successfulEvaluation__VAT__form": {
    "key": "tiw__successfulEvaluation__VAT__form",
    "ru": "",
    "ro": "",
    "en": "I acknowledge that I understand the purpose of the VAT 264 form and willingly consent to signing it.",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__chooseDevice__title__avoAfrica": {
    "key": "tiw__chooseDevice__title__avoAfrica",
    "ru": "",
    "ro": "",
    "en": "Which device do you want to Trade In?",
    "kz": "",
    "ua": "",
    "pl": "",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__successfulEvaluation__subtitle__avoAfrica": {
    "key": "tiw__successfulEvaluation__subtitle__avoAfrica",
    "ru": "Теперь вы точно знаете, сколько сэкономите в Trade-In. Осталось подписать SMS-договор",
    "ro": "Acum știți exact cât veți economisi prin Trade-In. Rămâne să semnați contractul prin SMS.",
    "en": "Now you know exactly how much you will save with Trade in. All that's left is to sign an SMS Agreement",
    "kz": "Енді сіз Trade-In-де қанша үнемдейтіндігіңізді білесіз. SMS-шартқа қол қою қалды",
    "ua": "Тепер ви точно знаєте, скільки заощадите у Trade-In. Залишилось підписати SMS-договір",
    "pl": "Teraz wiesz dokładnie, ile zaoszczędzisz na wymianie. Pozostaje podpisać umowę SMS",
    "ge": "ახლა უკვე ზუსტად იცი რამდენს დაზოგავ Trade-In-ით. დარჩა მხოლოდ SMS შეთანხმების გაფორმება",
    "az": "İndi siz Trade-In-də nə qədər qənaət edəcəyinizi dəqiq bilirsiniz. Sadəcə SMS müqaviləsini imzalamaq qalır",
    "": ""
  },
  "tiw__personAuthentication__title": {
    "key": "tiw__personAuthentication__title",
    "ru": "",
    "ro": "",
    "en": "Authentication",
    "kz": "Аутентификация",
    "ua": "",
    "pl": "Uwierzytelnianie",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__personAuthentication__text": {
    "key": "tiw__personAuthentication__text",
    "ru": "",
    "ro": "",
    "en": "Please prepare your identity document and make sure it is valid. We also require to accept our Terms and conditions and agree to processing your personal data.",
    "kz": "Жеке басыңызды куәландыратын құжатты дайындаңыз және оның жарамды екеніне көз жеткізіңіз. Біз сізден біздің шарттарымыз бен ережелерімізді қабылдауыңызды, сондай-ақ Сіздің жеке деректеріңізді өңдеуге келісім беруіңізді сұраймыз.",
    "ua": "",
    "pl": "Prosimy o przygotowanie dokumentu tożsamości i upewnienie się, że jest on ważny. Wymagamy również zaakceptowania naszych Warunków użytkowania i wyrażenia zgody na przetwarzanie danych osobowych.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__personAuthentication__success__title": {
    "key": "tiw__personAuthentication__success__title",
    "ru": "",
    "ro": "",
    "en": "Authentication Successful",
    "kz": "Аутентификация сәтті өтті",
    "ua": "",
    "pl": "Weryfikacja zakończona pomyślnie",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__personAuthentication__success__text": {
    "key": "tiw__personAuthentication__success__text",
    "ru": "",
    "ro": "",
    "en": "Please check the accuracy of certain information. If you will find any inaccuracies, please resubmit the document with new photographs",
    "kz": "Деректердің дұрыстығын тексеріңіз. Егер қандай да бір дәлсіздіктер табылса, құжатты жаңа фотосуреттермен қайта жіберіңіз",
    "ua": "",
    "pl": "Twoja tożsamość została pomyślnie zweryfikowana.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__personAuthentication__error__title": {
    "key": "tiw__personAuthentication__error__title",
    "ru": "",
    "ro": "",
    "en": "Authentication Failed",
    "kz": "Аутентификация сәтсіз аяқталды",
    "ua": "",
    "pl": "Uwierzytelnianie nie powiodło się",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__personAuthentication__error__text": {
    "key": "tiw__personAuthentication__error__text",
    "ru": "",
    "ro": "",
    "en": "Sorry, we are unable to verify your identity",
    "kz": "Кешіріңіз, біз сіздің жеке басыңызды растай алмаймыз",
    "ua": "",
    "pl": "Przepraszamy, nie możemy zweryfikować Twojej tożsamości.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__btn__quit": {
    "key": "tiw__btn__quit",
    "ru": "",
    "ro": "",
    "en": "quit",
    "kz": "Жүйеден шығу",
    "ua": "",
    "pl": "Zakończ",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__repeatButton": {
    "key": "tiw__person__repeatButton",
    "ru": "",
    "ro": "",
    "en": "Repeat authentication process",
    "kz": "Аутентификация процесін қайталаңыз",
    "ua": "",
    "pl": "Powtórz proces uwierzytelniania",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__title": {
    "key": "tiw__person__upload__title",
    "ru": "",
    "ro": "",
    "en": "Upload an image of your document",
    "kz": "Құжаттың суретін жүктеңіз",
    "ua": "",
    "pl": "Prześlij obraz swojego dokumentu",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentGuide": {
    "key": "tiw__person__upload__documentGuide",
    "ru": "",
    "ro": "",
    "en": "Document preparation guide",
    "kz": "Құжатты дайындау бойынша нұсқаулық",
    "ua": "",
    "pl": "Przewodnik po przygotowywaniu dokumentów",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentGuide__1": {
    "key": "tiw__person__upload__documentGuide__1",
    "ru": "",
    "ro": "",
    "en": "Prepare a clear photo/scan of the document",
    "kz": "Нақты фотосуретті/құжат сканерін айындаңыз",
    "ua": "",
    "pl": "Przygotuj wyraźne zdjęcie/skan dokumentu.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentGuide__2": {
    "key": "tiw__person__upload__documentGuide__2",
    "ru": "",
    "ro": "",
    "en": "If the document is double-sided, take a photo of both sides",
    "kz": "Егер құжат екі жақты болса, екі жағын да суретке түсіріңіз",
    "ua": "",
    "pl": "Jeśli dokument jest dwustronny, zrób zdjęcie obu stron.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentGuide__3": {
    "key": "tiw__person__upload__documentGuide__3",
    "ru": "",
    "ro": "",
    "en": "The document should be well-lit, without overexposed or dark areas",
    "kz": "Құжат жақсы жарықтандырылуы керек, шамадан тыс ашық немесе қараңғы аймақтар болмауы керек",
    "ua": "",
    "pl": "Dokument powinien być dobrze oświetlony, bez prześwietlonych lub zaciemnionych obszarów.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentGuide__4": {
    "key": "tiw__person__upload__documentGuide__4",
    "ru": "",
    "ro": "",
    "en": "Do not use a flash, glare reduces the accuracy of recognition",
    "kz": "Жарқылды пайдаланбаңыз, жарқырау тану дәлдігін төмендетеді",
    "ua": "",
    "pl": "Nie używaj lampy błyskowej, ponieważ odblaski zmniejszają dokładność rozpoznawania.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentGuide__5": {
    "key": "tiw__person__upload__documentGuide__5",
    "ru": "",
    "ro": "",
    "en": "The image must be sharp and free of blur",
    "kz": "Сурет анық және бұлыңғыр болмауы керек",
    "ua": "",
    "pl": "Obraz musi być ostry i pozbawiony rozmycia.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentGuide__6": {
    "key": "tiw__person__upload__documentGuide__6",
    "ru": "",
    "ro": "",
    "en": "The camera's tilt angle should not exceed ~10° horizontally or vertically",
    "kz": "Камераның көлбеу бұрышы көлденеңінен немесе тігінен ~10° аспауы керек",
    "ua": "",
    "pl": "Kąt nachylenia kamery nie powinien przekraczać ~10° w poziomie ani w pionie.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentGuide__7": {
    "key": "tiw__person__upload__documentGuide__7",
    "ru": "",
    "ro": "",
    "en": "The document should occupy ~70–80% of the frame; do not leave too little or too much background (no more than 20–30% of the space around it)",
    "kz": "Құжат кадрдың ~70-80% алуы керек; тым аз немесе тым көп фон қалдырмаңыз (оның айналасындағы кеңістіктің 20-30% - дан аспайды).",
    "ua": "",
    "pl": "Dokument powinien zajmować około 70–80% kadru; nie pozostawiaj zbyt mało lub zbyt dużo tła (nie więcej niż 20–30% przestrzeni wokół niego).",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentGuide__8": {
    "key": "tiw__person__upload__documentGuide__8",
    "ru": "",
    "ro": "",
    "en": "The document should have a noticeable tonal difference from the background (avoid \"light on light\" and \"dark on dark\")",
    "kz": "Құжат фоннан айтарлықтай өзгеше болуы керек (\"жарықта ашық\" және \"қараңғыда қараңғыдан\"аулақ болыңыз).",
    "ua": "",
    "pl": "Dokument powinien mieć wyraźną różnicę tonacyjną w stosunku do tła (należy unikać połączeń „jasne na jasnym” i „ciemne na ciemnym”).",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentGuide__9": {
    "key": "tiw__person__upload__documentGuide__9",
    "ru": "",
    "ro": "",
    "en": "A camera with at least Full HD (1920×1080) resolution and autofocus is recommended",
    "kz": "Кем дегенде Full HD (1920×1080) ажыратымдылығы және автофокусы бар камераны пайдалану ұсынылады",
    "ua": "",
    "pl": "Zalecana jest kamera o rozdzielczości co najmniej Full HD (1920×1080) i autofokusie.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentGuide__10": {
    "key": "tiw__person__upload__documentGuide__10",
    "ru": "",
    "ro": "",
    "en": "Fingers or other objects should not cover the document's data",
    "kz": "Саусақтар немесе басқа заттар құжат деректерін жаппауы керек",
    "ua": "",
    "pl": "Palce ani inne przedmioty nie powinny zasłaniać danych zawartych w dokumencie.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentGuide__11": {
    "key": "tiw__person__upload__documentGuide__11",
    "ru": "",
    "ro": "",
    "en": "The document's pages should be aligned; details must be clearly visible (avoid skewed or perspective distortions)",
    "kz": "Құжат беттері туралануы керек; деректер анық көрінуі керек (перспективаны бұрмалаудан немесе бұрмалаудан аулақ болыңыз)",
    "ua": "",
    "pl": "Strony dokumentu powinny być wyrównane; szczegóły muszą być wyraźnie widoczne (należy unikać przekrzywień lub zniekształceń perspektywicznych).",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__howToUpload": {
    "key": "tiw__person__upload__howToUpload",
    "ru": "",
    "ro": "",
    "en": "How to upload documents",
    "kz": "Құжаттарды қалай жүктеуге болады",
    "ua": "",
    "pl": "Jak przesłać dokumenty",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__howToUpload__1": {
    "key": "tiw__person__upload__howToUpload__1",
    "ru": "",
    "ro": "",
    "en": "Click \"Upload document\" and select the file",
    "kz": "\"Құжатты жүктеу\" түймесін басып, файлды таңдаңыз",
    "ua": "",
    "pl": "Kliknij „Prześlij dokument” i wybierz plik.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__howToUpload__2": {
    "key": "tiw__person__upload__howToUpload__2",
    "ru": "",
    "ro": "",
    "en": "Click the \"Continue\" button",
    "kz": "\"Жалғастыру\" түймесін басыңыз",
    "ua": "",
    "pl": "Kliknij przycisk „Kontynuuj”.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__howToUpload__3": {
    "key": "tiw__person__upload__howToUpload__3",
    "ru": "",
    "ro": "",
    "en": "Wait for the check to complete",
    "kz": "Тексеру аяқталғанша күтіңіз",
    "ua": "",
    "pl": "Poczekaj na zakończenie sprawdzania.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__howToUpload__4": {
    "key": "tiw__person__upload__howToUpload__4",
    "ru": "",
    "ro": "",
    "en": "If the check fails, upload a better quality photo or another copy of the document",
    "kz": "Егер тексеру сәтсіз болса, сапалы фотосуретті немесе құжаттың басқа көшірмесін жүктеп алыңыз",
    "ua": "",
    "pl": "Jeśli weryfikacja nie powiedzie się, prześlij zdjęcie lepszej jakości lub inną kopię dokumentu.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__howToUpload__5": {
    "key": "tiw__person__upload__howToUpload__5",
    "ru": "",
    "ro": "",
    "en": "You can change your research plan",
    "kz": "Сіз ақпарат жинау жоспарын өзгерте аласыз",
    "ua": "",
    "pl": "Możesz zmienić swój plan badań.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__examples": {
    "key": "tiw__person__upload__examples",
    "ru": "",
    "ro": "",
    "en": "Examples of documents",
    "kz": "Құжаттардың мысалдары",
    "ua": "",
    "pl": "Przykłady dokumentów",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentImageFront": {
    "key": "tiw__person__upload__documentImageFront",
    "ru": "",
    "ro": "",
    "en": "Document front side",
    "kz": "Құжаттың алдыңғы жағы",
    "ua": "",
    "pl": "Strona przednia dokumentu",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__documentImageBack": {
    "key": "tiw__person__upload__documentImageBack",
    "ru": "",
    "ro": "",
    "en": "Document back side",
    "kz": "Құжаттың артқы жағы",
    "ua": "",
    "pl": "Tył dokumentu",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__image": {
    "key": "tiw__person__upload__image",
    "ru": "",
    "ro": "",
    "en": "Upload an image",
    "kz": "Суретті жүктеңіз",
    "ua": "",
    "pl": "Prześlij obraz",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__images": {
    "key": "tiw__person__upload__images",
    "ru": "",
    "ro": "",
    "en": "Upload more images",
    "kz": "Қосымша суреттерді жүктеңіз",
    "ua": "",
    "pl": "Prześlij więcej zdjęć",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__person__upload__confirmAccuracy": {
    "key": "tiw__person__upload__confirmAccuracy",
    "ru": "",
    "ro": "",
    "en": "I confirm the accuracy of the data",
    "kz": "Мен деректердің дәлдігін растаймын",
    "ua": "",
    "pl": "Potwierdzam poprawność danych.",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__creditCardPreAuthorization__accepted": {
    "key": "tiw__creditCardPreAuthorization__accepted",
    "ru": "",
    "ro": "",
    "en": "I accept <a href=\"https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh_2026-04-30.pdf\" target=\"_blank\">Terms and Conditions</a>",
    "kz": "Мен қабылдаймын <a href=\"https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh_2026-04-30.pdf\" target=\"_blank\">Ережелер мен шарттар</a>",
    "ua": "",
    "pl": "Akceptuję <a href=\"https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh_2026-04-30.pdf\" target=\"_blank\">Regulamin</a>",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__creditCardPreAuthorization__agree": {
    "key": "tiw__creditCardPreAuthorization__agree",
    "ru": "",
    "ro": "",
    "en": "I agree to the processing of my personal data as described in the <a href=\"https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf\" target=\"_blank\"> Consent to Personal Data Processing",
    "kz": "Менің дербес деректерімді өңдеуге, онда сипатталғандай, келісімімді беремін <a href=\"https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf\" target=\"_blank\"> Дербес деректерді өңдеуге келісім",
    "ua": "",
    "pl": "Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z <a href=\"https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf \"target=\"_blank\">Polityką przetwarzania danych</a>",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__start": {
    "key": "tiw__start",
    "ru": "",
    "ro": "",
    "en": "Start",
    "kz": "Бастау",
    "ua": "",
    "pl": "Rozpocznij",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__forms__dateOfIssue": {
    "key": "tiw__forms__dateOfIssue",
    "ru": "",
    "ro": "",
    "en": "Date of Issue",
    "kz": "Берілген күні",
    "ua": "",
    "pl": "Data wydania",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__dateOfBirth": {
    "key": "tiw__dateOfBirth",
    "ru": "",
    "ro": "",
    "en": "Date of Birth",
    "kz": "Туған күні",
    "ua": "",
    "pl": "Data urodzenia",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__nameOfIssuingAuthority": {
    "key": "tiw__nameOfIssuingAuthority",
    "ru": "",
    "ro": "",
    "en": "Name of the issuing authority",
    "kz": "Құжатты берген органның атауы",
    "ua": "",
    "pl": "Nazwa organu wydającego",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__dateOfExpiry": {
    "key": "tiw__dateOfExpiry",
    "ru": "",
    "ro": "",
    "en": "Date of expiry",
    "kz": "Жарамдылық мерзімі",
    "ua": "",
    "pl": "Data ważności",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__male": {
    "key": "tiw__male",
    "ru": "",
    "ro": "",
    "en": "Male",
    "kz": "Еркек",
    "ua": "",
    "pl": "Mężczyzna",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__female": {
    "key": "tiw__female",
    "ru": "",
    "ro": "",
    "en": "Female",
    "kz": "Әйел",
    "ua": "",
    "pl": "Kobieta",
    "ge": "",
    "az": "",
    "": ""
  },
  "tiw__enterImei__serial": {
    "key": "tiw__enterImei__serial",
    "ru": "Серийный номер",
    "ro": "Număr de serie",
    "en": "Serial number",
    "kz": "Сериялық нөмір",
    "ua": "Серійний номер",
    "pl": "Numer seryjny",
    "ge": "სერიული ნომერი",
    "az": "Seriya nömrəsi",
    "": ""
  },
  "tiw__enterImei__serial__error__length": {
    "key": "tiw__enterImei__serial__error__length",
    "ru": "Это поле должно состоять из 5 до 25 символов",
    "ro": "Acest câmp trebuie să conțină între 5 și 25 de caractere.",
    "en": "This field must contain between 5 and 25 characters.",
    "kz": "Бұл өріс 5-тен 25 таңбаға дейін болуы керек.",
    "ua": "Це поле має містити від 5 до 25 символів.",
    "pl": "Pole musi zawierać od 5 do 25 znaków.",
    "ge": "ეს ველი უნდა შეიცავდეს 5-დან 25 სიმბოლომდე.",
    "az": "Bu sahə 5 ilə 25 arasında simvoldan ibarət olmalıdır.",
    "": ""
  },
  "tiw__enterImei__title-serial": {
    "key": "tiw__enterImei__title-serial",
    "ru": "Введите серийный номер сдаваемого устройства",
    "ro": "Introduceți numărul de serie al dispozitivului pe care îl predați",
    "en": "Enter the serial number of the device you are handing over",
    "kz": "Беріп жатқан құрылғының сериялық нөмірін енгізіңіз",
    "ua": "Введіть серійний номер пристрою, що здається",
    "pl": "Wprowadź numer seryjny urządzenia, które przekazujesz",
    "ge": "შეიყვანეთ იმ მოწყობილობის სერიული ნომერი, რომელსაც გადასცემთ",
    "az": "Təhvil verdiyiniz cihazın seriya nömrəsini daxil edin",
    "": ""
  },
  "tiw__enterImei__status-serial": {
    "key": "tiw__enterImei__status-serial",
    "ru": "Идет проверка серийного номера, до 60 секунд ожидания...",
    "ro": "Se verifică numărul de serie, timp de așteptare de până la 60 de secunde...",
    "en": "The serial number is being checked, up to 60 seconds of waiting...",
    "kz": "Сериялық нөмір тексерілуде, 60 секундқа дейін күтуге болады...",
    "ua": "Триває перевірка серійного номеру, до 60 секунд очікування...",
    "pl": "Numer seryjny jest sprawdzany, czas oczekiwania wynosi do 60 sekund...",
    "ge": "სერიული ნომერი მოწმდება, ლოდინი 60 წამამდეა...",
    "az": "Seriya nömrəsi yoxlanılır, 60 saniyəyə qədər gözləmə müddəti var...",
    "": ""
  }
};
 export default TRANSLATIONS